const dynamicIconImports = {
  'Sorting': () => import('./icons/Sorting'),
  'SortingDown': () => import('./icons/SortingDown'),
  'SortingUp': () => import('./icons/SortingUp'),
  'abc': () => import('./icons/abc'),
  'ac_unit': () => import('./icons/ac_unit'),
  'access_alarm': () => import('./icons/access_alarm'),
  'access_alarms': () => import('./icons/access_alarms'),
  'access_time': () => import('./icons/access_time'),
  'access_time_filled': () => import('./icons/access_time_filled'),
  'accessibility': () => import('./icons/accessibility'),
  'accessibility_new': () => import('./icons/accessibility_new'),
  'accessible': () => import('./icons/accessible'),
  'accessible_forward': () => import('./icons/accessible_forward'),
  'account_balance': () => import('./icons/account_balance'),
  'account_balance_wallet': () => import('./icons/account_balance_wallet'),
  'account_box': () => import('./icons/account_box'),
  'account_circle': () => import('./icons/account_circle'),
  'account_tree': () => import('./icons/account_tree'),
  'ad_units': () => import('./icons/ad_units'),
  'adb': () => import('./icons/adb'),
  'add': () => import('./icons/add'),
  'add_a_photo': () => import('./icons/add_a_photo'),
  'add_alarm': () => import('./icons/add_alarm'),
  'add_alert': () => import('./icons/add_alert'),
  'add_box': () => import('./icons/add_box'),
  'add_business': () => import('./icons/add_business'),
  'add_card': () => import('./icons/add_card'),
  'add_chart': () => import('./icons/add_chart'),
  'add_circle': () => import('./icons/add_circle'),
  'add_circle_outline': () => import('./icons/add_circle_outline'),
  'add_comment': () => import('./icons/add_comment'),
  'add_home': () => import('./icons/add_home'),
  'add_home_work': () => import('./icons/add_home_work'),
  'add_ic_call': () => import('./icons/add_ic_call'),
  'add_link': () => import('./icons/add_link'),
  'add_location': () => import('./icons/add_location'),
  'add_location_alt': () => import('./icons/add_location_alt'),
  'add_moderator': () => import('./icons/add_moderator'),
  'add_photo_alternate': () => import('./icons/add_photo_alternate'),
  'add_reaction': () => import('./icons/add_reaction'),
  'add_road': () => import('./icons/add_road'),
  'add_shopping_cart': () => import('./icons/add_shopping_cart'),
  'add_task': () => import('./icons/add_task'),
  'add_to_drive': () => import('./icons/add_to_drive'),
  'add_to_home_screen': () => import('./icons/add_to_home_screen'),
  'add_to_photos': () => import('./icons/add_to_photos'),
  'add_to_queue': () => import('./icons/add_to_queue'),
  'addchart': () => import('./icons/addchart'),
  'adf_scanner': () => import('./icons/adf_scanner'),
  'adjust': () => import('./icons/adjust'),
  'admin_panel_settings': () => import('./icons/admin_panel_settings'),
  'ads_click': () => import('./icons/ads_click'),
  'agriculture': () => import('./icons/agriculture'),
  'air': () => import('./icons/air'),
  'airline_seat_flat': () => import('./icons/airline_seat_flat'),
  'airline_seat_flat_angled': () => import('./icons/airline_seat_flat_angled'),
  'airline_seat_individual_suite': () => import('./icons/airline_seat_individual_suite'),
  'airline_seat_legroom_extra': () => import('./icons/airline_seat_legroom_extra'),
  'airline_seat_legroom_normal': () => import('./icons/airline_seat_legroom_normal'),
  'airline_seat_legroom_reduced': () => import('./icons/airline_seat_legroom_reduced'),
  'airline_seat_recline_extra': () => import('./icons/airline_seat_recline_extra'),
  'airline_seat_recline_normal': () => import('./icons/airline_seat_recline_normal'),
  'airline_stops': () => import('./icons/airline_stops'),
  'airlines': () => import('./icons/airlines'),
  'airplane_ticket': () => import('./icons/airplane_ticket'),
  'airplanemode_active': () => import('./icons/airplanemode_active'),
  'airplanemode_inactive': () => import('./icons/airplanemode_inactive'),
  'airplay': () => import('./icons/airplay'),
  'airport_shuttle': () => import('./icons/airport_shuttle'),
  'alarm': () => import('./icons/alarm'),
  'alarm_add': () => import('./icons/alarm_add'),
  'alarm_off': () => import('./icons/alarm_off'),
  'alarm_on': () => import('./icons/alarm_on'),
  'album': () => import('./icons/album'),
  'align_horizontal_center': () => import('./icons/align_horizontal_center'),
  'align_horizontal_left': () => import('./icons/align_horizontal_left'),
  'align_horizontal_right': () => import('./icons/align_horizontal_right'),
  'align_vertical_bottom': () => import('./icons/align_vertical_bottom'),
  'align_vertical_center': () => import('./icons/align_vertical_center'),
  'align_vertical_top': () => import('./icons/align_vertical_top'),
  'all_inbox': () => import('./icons/all_inbox'),
  'all_inclusive': () => import('./icons/all_inclusive'),
  'all_out': () => import('./icons/all_out'),
  'alt_route': () => import('./icons/alt_route'),
  'alternate_email': () => import('./icons/alternate_email'),
  'analytics': () => import('./icons/analytics'),
  'anchor': () => import('./icons/anchor'),
  'android': () => import('./icons/android'),
  'animation': () => import('./icons/animation'),
  'announcement': () => import('./icons/announcement'),
  'aod': () => import('./icons/aod'),
  'apartment': () => import('./icons/apartment'),
  'api': () => import('./icons/api'),
  'app_blocking': () => import('./icons/app_blocking'),
  'app_registration': () => import('./icons/app_registration'),
  'app_settings_alt': () => import('./icons/app_settings_alt'),
  'app_shortcut': () => import('./icons/app_shortcut'),
  'approval': () => import('./icons/approval'),
  'apps': () => import('./icons/apps'),
  'apps_outage': () => import('./icons/apps_outage'),
  'architecture': () => import('./icons/architecture'),
  'archive': () => import('./icons/archive'),
  'area_chart': () => import('./icons/area_chart'),
  'arrow_back': () => import('./icons/arrow_back'),
  'arrow_back_ios': () => import('./icons/arrow_back_ios'),
  'arrow_back_ios_new': () => import('./icons/arrow_back_ios_new'),
  'arrow_circle_down': () => import('./icons/arrow_circle_down'),
  'arrow_circle_left': () => import('./icons/arrow_circle_left'),
  'arrow_circle_right': () => import('./icons/arrow_circle_right'),
  'arrow_circle_up': () => import('./icons/arrow_circle_up'),
  'arrow_downward': () => import('./icons/arrow_downward'),
  'arrow_drop_down': () => import('./icons/arrow_drop_down'),
  'arrow_drop_down_circle': () => import('./icons/arrow_drop_down_circle'),
  'arrow_drop_up': () => import('./icons/arrow_drop_up'),
  'arrow_forward': () => import('./icons/arrow_forward'),
  'arrow_forward_ios': () => import('./icons/arrow_forward_ios'),
  'arrow_left': () => import('./icons/arrow_left'),
  'arrow_outward': () => import('./icons/arrow_outward'),
  'arrow_right': () => import('./icons/arrow_right'),
  'arrow_right_alt': () => import('./icons/arrow_right_alt'),
  'arrow_upward': () => import('./icons/arrow_upward'),
  'art_track': () => import('./icons/art_track'),
  'article': () => import('./icons/article'),
  'aspect_ratio': () => import('./icons/aspect_ratio'),
  'assessment': () => import('./icons/assessment'),
  'assignment': () => import('./icons/assignment'),
  'assignment_ind': () => import('./icons/assignment_ind'),
  'assignment_late': () => import('./icons/assignment_late'),
  'assignment_return': () => import('./icons/assignment_return'),
  'assignment_returned': () => import('./icons/assignment_returned'),
  'assignment_turned_in': () => import('./icons/assignment_turned_in'),
  'assist_walker': () => import('./icons/assist_walker'),
  'assistant': () => import('./icons/assistant'),
  'assistant_direction': () => import('./icons/assistant_direction'),
  'assistant_photo': () => import('./icons/assistant_photo'),
  'assured_workload': () => import('./icons/assured_workload'),
  'atm': () => import('./icons/atm'),
  'attach_email': () => import('./icons/attach_email'),
  'attach_file': () => import('./icons/attach_file'),
  'attach_money': () => import('./icons/attach_money'),
  'attachment': () => import('./icons/attachment'),
  'attractions': () => import('./icons/attractions'),
  'attribution': () => import('./icons/attribution'),
  'audio_file': () => import('./icons/audio_file'),
  'audiotrack': () => import('./icons/audiotrack'),
  'auto_awesome': () => import('./icons/auto_awesome'),
  'auto_awesome_mosaic': () => import('./icons/auto_awesome_mosaic'),
  'auto_awesome_motion': () => import('./icons/auto_awesome_motion'),
  'auto_delete': () => import('./icons/auto_delete'),
  'auto_fix_high': () => import('./icons/auto_fix_high'),
  'auto_fix_normal': () => import('./icons/auto_fix_normal'),
  'auto_fix_off': () => import('./icons/auto_fix_off'),
  'auto_graph': () => import('./icons/auto_graph'),
  'auto_mode': () => import('./icons/auto_mode'),
  'auto_stories': () => import('./icons/auto_stories'),
  'autofps_select': () => import('./icons/autofps_select'),
  'autorenew': () => import('./icons/autorenew'),
  'av_timer': () => import('./icons/av_timer'),
  'baby_changing_station': () => import('./icons/baby_changing_station'),
  'back_hand': () => import('./icons/back_hand'),
  'backpack': () => import('./icons/backpack'),
  'backspace': () => import('./icons/backspace'),
  'backup': () => import('./icons/backup'),
  'backup_table': () => import('./icons/backup_table'),
  'badge': () => import('./icons/badge'),
  'bakery_dining': () => import('./icons/bakery_dining'),
  'balance': () => import('./icons/balance'),
  'balcony': () => import('./icons/balcony'),
  'ballot': () => import('./icons/ballot'),
  'bar_chart': () => import('./icons/bar_chart'),
  'batch_prediction': () => import('./icons/batch_prediction'),
  'bathroom': () => import('./icons/bathroom'),
  'bathtub': () => import('./icons/bathtub'),
  'battery_0_bar': () => import('./icons/battery_0_bar'),
  'battery_1_bar': () => import('./icons/battery_1_bar'),
  'battery_2_bar': () => import('./icons/battery_2_bar'),
  'battery_3_bar': () => import('./icons/battery_3_bar'),
  'battery_4_bar': () => import('./icons/battery_4_bar'),
  'battery_5_bar': () => import('./icons/battery_5_bar'),
  'battery_6_bar': () => import('./icons/battery_6_bar'),
  'battery_alert': () => import('./icons/battery_alert'),
  'battery_charging_full': () => import('./icons/battery_charging_full'),
  'battery_full': () => import('./icons/battery_full'),
  'battery_saver': () => import('./icons/battery_saver'),
  'battery_std': () => import('./icons/battery_std'),
  'battery_unknown': () => import('./icons/battery_unknown'),
  'beach_access': () => import('./icons/beach_access'),
  'bed': () => import('./icons/bed'),
  'bedroom_baby': () => import('./icons/bedroom_baby'),
  'bedroom_child': () => import('./icons/bedroom_child'),
  'bedroom_parent': () => import('./icons/bedroom_parent'),
  'bedtime': () => import('./icons/bedtime'),
  'bedtime_off': () => import('./icons/bedtime_off'),
  'beenhere': () => import('./icons/beenhere'),
  'bento': () => import('./icons/bento'),
  'bike_scooter': () => import('./icons/bike_scooter'),
  'biotech': () => import('./icons/biotech'),
  'blender': () => import('./icons/blender'),
  'blind': () => import('./icons/blind'),
  'blinds': () => import('./icons/blinds'),
  'blinds_closed': () => import('./icons/blinds_closed'),
  'block': () => import('./icons/block'),
  'bloodtype': () => import('./icons/bloodtype'),
  'bluetooth': () => import('./icons/bluetooth'),
  'bluetooth_audio': () => import('./icons/bluetooth_audio'),
  'bluetooth_connected': () => import('./icons/bluetooth_connected'),
  'bluetooth_disabled': () => import('./icons/bluetooth_disabled'),
  'bluetooth_drive': () => import('./icons/bluetooth_drive'),
  'bluetooth_searching': () => import('./icons/bluetooth_searching'),
  'blur_circular': () => import('./icons/blur_circular'),
  'blur_linear': () => import('./icons/blur_linear'),
  'blur_off': () => import('./icons/blur_off'),
  'blur_on': () => import('./icons/blur_on'),
  'bolt': () => import('./icons/bolt'),
  'book': () => import('./icons/book'),
  'book_online': () => import('./icons/book_online'),
  'bookmark': () => import('./icons/bookmark'),
  'bookmark_add': () => import('./icons/bookmark_add'),
  'bookmark_added': () => import('./icons/bookmark_added'),
  'bookmark_border': () => import('./icons/bookmark_border'),
  'bookmark_remove': () => import('./icons/bookmark_remove'),
  'bookmarks': () => import('./icons/bookmarks'),
  'border_all': () => import('./icons/border_all'),
  'border_bottom': () => import('./icons/border_bottom'),
  'border_clear': () => import('./icons/border_clear'),
  'border_color': () => import('./icons/border_color'),
  'border_horizontal': () => import('./icons/border_horizontal'),
  'border_inner': () => import('./icons/border_inner'),
  'border_left': () => import('./icons/border_left'),
  'border_outer': () => import('./icons/border_outer'),
  'border_right': () => import('./icons/border_right'),
  'border_style': () => import('./icons/border_style'),
  'border_top': () => import('./icons/border_top'),
  'border_vertical': () => import('./icons/border_vertical'),
  'boy': () => import('./icons/boy'),
  'branding_watermark': () => import('./icons/branding_watermark'),
  'breakfast_dining': () => import('./icons/breakfast_dining'),
  'brightness_1': () => import('./icons/brightness_1'),
  'brightness_2': () => import('./icons/brightness_2'),
  'brightness_3': () => import('./icons/brightness_3'),
  'brightness_4': () => import('./icons/brightness_4'),
  'brightness_5': () => import('./icons/brightness_5'),
  'brightness_6': () => import('./icons/brightness_6'),
  'brightness_7': () => import('./icons/brightness_7'),
  'brightness_auto': () => import('./icons/brightness_auto'),
  'brightness_high': () => import('./icons/brightness_high'),
  'brightness_low': () => import('./icons/brightness_low'),
  'brightness_medium': () => import('./icons/brightness_medium'),
  'broadcast_on_home': () => import('./icons/broadcast_on_home'),
  'broadcast_on_personal': () => import('./icons/broadcast_on_personal'),
  'broken_image': () => import('./icons/broken_image'),
  'browse_gallery': () => import('./icons/browse_gallery'),
  'browser_not_supported': () => import('./icons/browser_not_supported'),
  'browser_updated': () => import('./icons/browser_updated'),
  'brunch_dining': () => import('./icons/brunch_dining'),
  'brush': () => import('./icons/brush'),
  'bubble_chart': () => import('./icons/bubble_chart'),
  'bug_report': () => import('./icons/bug_report'),
  'build': () => import('./icons/build'),
  'build_circle': () => import('./icons/build_circle'),
  'bungalow': () => import('./icons/bungalow'),
  'burst_mode': () => import('./icons/burst_mode'),
  'bus_alert': () => import('./icons/bus_alert'),
  'business': () => import('./icons/business'),
  'business_center': () => import('./icons/business_center'),
  'cabin': () => import('./icons/cabin'),
  'cable': () => import('./icons/cable'),
  'cached': () => import('./icons/cached'),
  'cake': () => import('./icons/cake'),
  'calculate': () => import('./icons/calculate'),
  'calendar_month': () => import('./icons/calendar_month'),
  'calendar_today': () => import('./icons/calendar_today'),
  'calendar_view_day': () => import('./icons/calendar_view_day'),
  'calendar_view_month': () => import('./icons/calendar_view_month'),
  'calendar_view_week': () => import('./icons/calendar_view_week'),
  'call': () => import('./icons/call'),
  'call_end': () => import('./icons/call_end'),
  'call_made': () => import('./icons/call_made'),
  'call_merge': () => import('./icons/call_merge'),
  'call_missed': () => import('./icons/call_missed'),
  'call_missed_outgoing': () => import('./icons/call_missed_outgoing'),
  'call_received': () => import('./icons/call_received'),
  'call_split': () => import('./icons/call_split'),
  'call_to_action': () => import('./icons/call_to_action'),
  'camera': () => import('./icons/camera'),
  'camera_alt': () => import('./icons/camera_alt'),
  'camera_enhance': () => import('./icons/camera_enhance'),
  'camera_front': () => import('./icons/camera_front'),
  'camera_indoor': () => import('./icons/camera_indoor'),
  'camera_outdoor': () => import('./icons/camera_outdoor'),
  'camera_rear': () => import('./icons/camera_rear'),
  'camera_roll': () => import('./icons/camera_roll'),
  'cameraswitch': () => import('./icons/cameraswitch'),
  'campaign': () => import('./icons/campaign'),
  'cancel': () => import('./icons/cancel'),
  'cancel_presentation': () => import('./icons/cancel_presentation'),
  'cancel_schedule_send': () => import('./icons/cancel_schedule_send'),
  'candlestick_chart': () => import('./icons/candlestick_chart'),
  'car_crash': () => import('./icons/car_crash'),
  'car_rental': () => import('./icons/car_rental'),
  'car_repair': () => import('./icons/car_repair'),
  'card_giftcard': () => import('./icons/card_giftcard'),
  'card_membership': () => import('./icons/card_membership'),
  'card_travel': () => import('./icons/card_travel'),
  'carpenter': () => import('./icons/carpenter'),
  'cases': () => import('./icons/cases'),
  'casino': () => import('./icons/casino'),
  'cast': () => import('./icons/cast'),
  'cast_connected': () => import('./icons/cast_connected'),
  'cast_for_education': () => import('./icons/cast_for_education'),
  'castle': () => import('./icons/castle'),
  'catching_pokemon': () => import('./icons/catching_pokemon'),
  'category': () => import('./icons/category'),
  'celebration': () => import('./icons/celebration'),
  'cell_tower': () => import('./icons/cell_tower'),
  'cell_wifi': () => import('./icons/cell_wifi'),
  'center_focus_strong': () => import('./icons/center_focus_strong'),
  'center_focus_weak': () => import('./icons/center_focus_weak'),
  'chair': () => import('./icons/chair'),
  'chair_alt': () => import('./icons/chair_alt'),
  'chalet': () => import('./icons/chalet'),
  'change_circle': () => import('./icons/change_circle'),
  'change_history': () => import('./icons/change_history'),
  'charging_station': () => import('./icons/charging_station'),
  'chat': () => import('./icons/chat'),
  'chat_bubble': () => import('./icons/chat_bubble'),
  'chat_bubble_outline': () => import('./icons/chat_bubble_outline'),
  'check': () => import('./icons/check'),
  'check_box': () => import('./icons/check_box'),
  'check_box_outline_blank': () => import('./icons/check_box_outline_blank'),
  'check_circle': () => import('./icons/check_circle'),
  'check_circle_outline': () => import('./icons/check_circle_outline'),
  'checklist': () => import('./icons/checklist'),
  'checklist_rtl': () => import('./icons/checklist_rtl'),
  'checkroom': () => import('./icons/checkroom'),
  'chevron_left': () => import('./icons/chevron_left'),
  'chevron_right': () => import('./icons/chevron_right'),
  'child_care': () => import('./icons/child_care'),
  'child_friendly': () => import('./icons/child_friendly'),
  'chrome_reader_mode': () => import('./icons/chrome_reader_mode'),
  'church': () => import('./icons/church'),
  'circle': () => import('./icons/circle'),
  'circle_notifications': () => import('./icons/circle_notifications'),
  'class': () => import('./icons/class'),
  'clean_hands': () => import('./icons/clean_hands'),
  'cleaning_services': () => import('./icons/cleaning_services'),
  'clear': () => import('./icons/clear'),
  'clear_all': () => import('./icons/clear_all'),
  'close': () => import('./icons/close'),
  'close_fullscreen': () => import('./icons/close_fullscreen'),
  'closed_caption': () => import('./icons/closed_caption'),
  'closed_caption_disabled': () => import('./icons/closed_caption_disabled'),
  'closed_caption_off': () => import('./icons/closed_caption_off'),
  'cloud': () => import('./icons/cloud'),
  'cloud_circle': () => import('./icons/cloud_circle'),
  'cloud_done': () => import('./icons/cloud_done'),
  'cloud_download': () => import('./icons/cloud_download'),
  'cloud_off': () => import('./icons/cloud_off'),
  'cloud_queue': () => import('./icons/cloud_queue'),
  'cloud_sync': () => import('./icons/cloud_sync'),
  'cloud_upload': () => import('./icons/cloud_upload'),
  'co2': () => import('./icons/co2'),
  'co_present': () => import('./icons/co_present'),
  'code': () => import('./icons/code'),
  'code_off': () => import('./icons/code_off'),
  'coffee': () => import('./icons/coffee'),
  'coffee_maker': () => import('./icons/coffee_maker'),
  'collections': () => import('./icons/collections'),
  'collections_bookmark': () => import('./icons/collections_bookmark'),
  'color_lens': () => import('./icons/color_lens'),
  'colorize': () => import('./icons/colorize'),
  'comment': () => import('./icons/comment'),
  'comment_bank': () => import('./icons/comment_bank'),
  'comments_disabled': () => import('./icons/comments_disabled'),
  'commit': () => import('./icons/commit'),
  'commute': () => import('./icons/commute'),
  'compare': () => import('./icons/compare'),
  'compare_arrows': () => import('./icons/compare_arrows'),
  'compass_calibration': () => import('./icons/compass_calibration'),
  'compost': () => import('./icons/compost'),
  'compress': () => import('./icons/compress'),
  'computer': () => import('./icons/computer'),
  'confirmation_number': () => import('./icons/confirmation_number'),
  'connect_without_contact': () => import('./icons/connect_without_contact'),
  'connected_tv': () => import('./icons/connected_tv'),
  'connecting_airports': () => import('./icons/connecting_airports'),
  'construction': () => import('./icons/construction'),
  'contact_emergency': () => import('./icons/contact_emergency'),
  'contact_mail': () => import('./icons/contact_mail'),
  'contact_page': () => import('./icons/contact_page'),
  'contact_phone': () => import('./icons/contact_phone'),
  'contact_support': () => import('./icons/contact_support'),
  'contactless': () => import('./icons/contactless'),
  'contacts': () => import('./icons/contacts'),
  'content_copy': () => import('./icons/content_copy'),
  'content_cut': () => import('./icons/content_cut'),
  'content_paste': () => import('./icons/content_paste'),
  'content_paste_go': () => import('./icons/content_paste_go'),
  'content_paste_off': () => import('./icons/content_paste_off'),
  'content_paste_search': () => import('./icons/content_paste_search'),
  'contrast': () => import('./icons/contrast'),
  'control_camera': () => import('./icons/control_camera'),
  'control_point': () => import('./icons/control_point'),
  'control_point_duplicate': () => import('./icons/control_point_duplicate'),
  'cookie': () => import('./icons/cookie'),
  'copy_all': () => import('./icons/copy_all'),
  'copyright': () => import('./icons/copyright'),
  'coronavirus': () => import('./icons/coronavirus'),
  'corporate_fare': () => import('./icons/corporate_fare'),
  'cottage': () => import('./icons/cottage'),
  'countertops': () => import('./icons/countertops'),
  'create': () => import('./icons/create'),
  'create_new_folder': () => import('./icons/create_new_folder'),
  'credit_card': () => import('./icons/credit_card'),
  'credit_card_off': () => import('./icons/credit_card_off'),
  'credit_score': () => import('./icons/credit_score'),
  'crib': () => import('./icons/crib'),
  'crisis_alert': () => import('./icons/crisis_alert'),
  'crop': () => import('./icons/crop'),
  'crop_16_9': () => import('./icons/crop_16_9'),
  'crop_3_2': () => import('./icons/crop_3_2'),
  'crop_5_4': () => import('./icons/crop_5_4'),
  'crop_7_5': () => import('./icons/crop_7_5'),
  'crop_din': () => import('./icons/crop_din'),
  'crop_free': () => import('./icons/crop_free'),
  'crop_landscape': () => import('./icons/crop_landscape'),
  'crop_original': () => import('./icons/crop_original'),
  'crop_portrait': () => import('./icons/crop_portrait'),
  'crop_rotate': () => import('./icons/crop_rotate'),
  'crop_square': () => import('./icons/crop_square'),
  'cruelty_free': () => import('./icons/cruelty_free'),
  'css': () => import('./icons/css'),
  'currency_bitcoin': () => import('./icons/currency_bitcoin'),
  'currency_exchange': () => import('./icons/currency_exchange'),
  'currency_franc': () => import('./icons/currency_franc'),
  'currency_lira': () => import('./icons/currency_lira'),
  'currency_pound': () => import('./icons/currency_pound'),
  'currency_ruble': () => import('./icons/currency_ruble'),
  'currency_rupee': () => import('./icons/currency_rupee'),
  'currency_yen': () => import('./icons/currency_yen'),
  'currency_yuan': () => import('./icons/currency_yuan'),
  'curtains': () => import('./icons/curtains'),
  'curtains_closed': () => import('./icons/curtains_closed'),
  'cyclone': () => import('./icons/cyclone'),
  'dangerous': () => import('./icons/dangerous'),
  'dark_mode': () => import('./icons/dark_mode'),
  'dashboard': () => import('./icons/dashboard'),
  'dashboard_customize': () => import('./icons/dashboard_customize'),
  'data_array': () => import('./icons/data_array'),
  'data_exploration': () => import('./icons/data_exploration'),
  'data_object': () => import('./icons/data_object'),
  'data_saver_off': () => import('./icons/data_saver_off'),
  'data_saver_on': () => import('./icons/data_saver_on'),
  'data_thresholding': () => import('./icons/data_thresholding'),
  'data_usage': () => import('./icons/data_usage'),
  'dataset': () => import('./icons/dataset'),
  'dataset_linked': () => import('./icons/dataset_linked'),
  'date_range': () => import('./icons/date_range'),
  'deblur': () => import('./icons/deblur'),
  'deck': () => import('./icons/deck'),
  'dehaze': () => import('./icons/dehaze'),
  'delete': () => import('./icons/delete'),
  'delete_forever': () => import('./icons/delete_forever'),
  'delete_outline': () => import('./icons/delete_outline'),
  'delete_sweep': () => import('./icons/delete_sweep'),
  'delivery_dining': () => import('./icons/delivery_dining'),
  'density_large': () => import('./icons/density_large'),
  'density_medium': () => import('./icons/density_medium'),
  'density_small': () => import('./icons/density_small'),
  'departure_board': () => import('./icons/departure_board'),
  'description': () => import('./icons/description'),
  'deselect': () => import('./icons/deselect'),
  'design_services': () => import('./icons/design_services'),
  'desk': () => import('./icons/desk'),
  'desktop_access_disabled': () => import('./icons/desktop_access_disabled'),
  'desktop_mac': () => import('./icons/desktop_mac'),
  'desktop_windows': () => import('./icons/desktop_windows'),
  'details': () => import('./icons/details'),
  'developer_board': () => import('./icons/developer_board'),
  'developer_board_off': () => import('./icons/developer_board_off'),
  'developer_mode': () => import('./icons/developer_mode'),
  'device_hub': () => import('./icons/device_hub'),
  'device_thermostat': () => import('./icons/device_thermostat'),
  'device_unknown': () => import('./icons/device_unknown'),
  'devices': () => import('./icons/devices'),
  'devices_fold': () => import('./icons/devices_fold'),
  'devices_other': () => import('./icons/devices_other'),
  'dialer_sip': () => import('./icons/dialer_sip'),
  'dialpad': () => import('./icons/dialpad'),
  'diamond': () => import('./icons/diamond'),
  'difference': () => import('./icons/difference'),
  'dining': () => import('./icons/dining'),
  'dinner_dining': () => import('./icons/dinner_dining'),
  'directions': () => import('./icons/directions'),
  'directions_bike': () => import('./icons/directions_bike'),
  'directions_boat': () => import('./icons/directions_boat'),
  'directions_boat_filled': () => import('./icons/directions_boat_filled'),
  'directions_bus': () => import('./icons/directions_bus'),
  'directions_bus_filled': () => import('./icons/directions_bus_filled'),
  'directions_car': () => import('./icons/directions_car'),
  'directions_car_filled': () => import('./icons/directions_car_filled'),
  'directions_off': () => import('./icons/directions_off'),
  'directions_railway': () => import('./icons/directions_railway'),
  'directions_railway_filled': () => import('./icons/directions_railway_filled'),
  'directions_run': () => import('./icons/directions_run'),
  'directions_subway': () => import('./icons/directions_subway'),
  'directions_subway_filled': () => import('./icons/directions_subway_filled'),
  'directions_transit': () => import('./icons/directions_transit'),
  'directions_transit_filled': () => import('./icons/directions_transit_filled'),
  'directions_walk': () => import('./icons/directions_walk'),
  'dirty_lens': () => import('./icons/dirty_lens'),
  'disabled_by_default': () => import('./icons/disabled_by_default'),
  'disabled_visible': () => import('./icons/disabled_visible'),
  'disc_full': () => import('./icons/disc_full'),
  'discount': () => import('./icons/discount'),
  'display_settings': () => import('./icons/display_settings'),
  'diversity_1': () => import('./icons/diversity_1'),
  'diversity_2': () => import('./icons/diversity_2'),
  'diversity_3': () => import('./icons/diversity_3'),
  'dns': () => import('./icons/dns'),
  'do_disturb': () => import('./icons/do_disturb'),
  'do_disturb_alt': () => import('./icons/do_disturb_alt'),
  'do_disturb_off': () => import('./icons/do_disturb_off'),
  'do_disturb_on': () => import('./icons/do_disturb_on'),
  'do_not_disturb': () => import('./icons/do_not_disturb'),
  'do_not_disturb_alt': () => import('./icons/do_not_disturb_alt'),
  'do_not_disturb_off': () => import('./icons/do_not_disturb_off'),
  'do_not_disturb_on': () => import('./icons/do_not_disturb_on'),
  'do_not_disturb_on_total_silence': () => import('./icons/do_not_disturb_on_total_silence'),
  'do_not_step': () => import('./icons/do_not_step'),
  'do_not_touch': () => import('./icons/do_not_touch'),
  'dock': () => import('./icons/dock'),
  'document_scanner': () => import('./icons/document_scanner'),
  'domain': () => import('./icons/domain'),
  'domain_add': () => import('./icons/domain_add'),
  'domain_disabled': () => import('./icons/domain_disabled'),
  'domain_verification': () => import('./icons/domain_verification'),
  'done': () => import('./icons/done'),
  'done_all': () => import('./icons/done_all'),
  'done_outline': () => import('./icons/done_outline'),
  'donut_large': () => import('./icons/donut_large'),
  'donut_small': () => import('./icons/donut_small'),
  'door_back': () => import('./icons/door_back'),
  'door_front': () => import('./icons/door_front'),
  'door_sliding': () => import('./icons/door_sliding'),
  'doorbell': () => import('./icons/doorbell'),
  'double_arrow': () => import('./icons/double_arrow'),
  'downhill_skiing': () => import('./icons/downhill_skiing'),
  'download': () => import('./icons/download'),
  'download_done': () => import('./icons/download_done'),
  'download_for_offline': () => import('./icons/download_for_offline'),
  'downloading': () => import('./icons/downloading'),
  'drafts': () => import('./icons/drafts'),
  'drag_handle': () => import('./icons/drag_handle'),
  'drag_indicator': () => import('./icons/drag_indicator'),
  'draw': () => import('./icons/draw'),
  'drive_eta': () => import('./icons/drive_eta'),
  'drive_file_move': () => import('./icons/drive_file_move'),
  'drive_file_move_rtl': () => import('./icons/drive_file_move_rtl'),
  'drive_file_rename_outline': () => import('./icons/drive_file_rename_outline'),
  'drive_folder_upload': () => import('./icons/drive_folder_upload'),
  'dry': () => import('./icons/dry'),
  'dry_cleaning': () => import('./icons/dry_cleaning'),
  'duo': () => import('./icons/duo'),
  'dvr': () => import('./icons/dvr'),
  'dynamic_feed': () => import('./icons/dynamic_feed'),
  'dynamic_form': () => import('./icons/dynamic_form'),
  'e_mobiledata': () => import('./icons/e_mobiledata'),
  'earbuds': () => import('./icons/earbuds'),
  'earbuds_battery': () => import('./icons/earbuds_battery'),
  'east': () => import('./icons/east'),
  'edgesensor_high': () => import('./icons/edgesensor_high'),
  'edgesensor_low': () => import('./icons/edgesensor_low'),
  'edit': () => import('./icons/edit'),
  'edit_attributes': () => import('./icons/edit_attributes'),
  'edit_calendar': () => import('./icons/edit_calendar'),
  'edit_location': () => import('./icons/edit_location'),
  'edit_location_alt': () => import('./icons/edit_location_alt'),
  'edit_note': () => import('./icons/edit_note'),
  'edit_notifications': () => import('./icons/edit_notifications'),
  'edit_off': () => import('./icons/edit_off'),
  'edit_road': () => import('./icons/edit_road'),
  'egg': () => import('./icons/egg'),
  'egg_alt': () => import('./icons/egg_alt'),
  'eighteen_up_rating': () => import('./icons/eighteen_up_rating'),
  'eighteenmp': () => import('./icons/eighteenmp'),
  'eightk': () => import('./icons/eightk'),
  'eightk_plus': () => import('./icons/eightk_plus'),
  'eightmp': () => import('./icons/eightmp'),
  'eject': () => import('./icons/eject'),
  'elderly': () => import('./icons/elderly'),
  'elderly_woman': () => import('./icons/elderly_woman'),
  'electric_bike': () => import('./icons/electric_bike'),
  'electric_bolt': () => import('./icons/electric_bolt'),
  'electric_car': () => import('./icons/electric_car'),
  'electric_meter': () => import('./icons/electric_meter'),
  'electric_moped': () => import('./icons/electric_moped'),
  'electric_rickshaw': () => import('./icons/electric_rickshaw'),
  'electric_scooter': () => import('./icons/electric_scooter'),
  'electrical_services': () => import('./icons/electrical_services'),
  'elevator': () => import('./icons/elevator'),
  'elevenmp': () => import('./icons/elevenmp'),
  'email': () => import('./icons/email'),
  'emergency': () => import('./icons/emergency'),
  'emergency_recording': () => import('./icons/emergency_recording'),
  'emergency_share': () => import('./icons/emergency_share'),
  'emoji_emotions': () => import('./icons/emoji_emotions'),
  'emoji_events': () => import('./icons/emoji_events'),
  'emoji_food_beverage': () => import('./icons/emoji_food_beverage'),
  'emoji_nature': () => import('./icons/emoji_nature'),
  'emoji_objects': () => import('./icons/emoji_objects'),
  'emoji_people': () => import('./icons/emoji_people'),
  'emoji_symbols': () => import('./icons/emoji_symbols'),
  'emoji_transportation': () => import('./icons/emoji_transportation'),
  'energy_savings_leaf': () => import('./icons/energy_savings_leaf'),
  'engineering': () => import('./icons/engineering'),
  'enhanced_encryption': () => import('./icons/enhanced_encryption'),
  'equalizer': () => import('./icons/equalizer'),
  'error': () => import('./icons/error'),
  'error_outline': () => import('./icons/error_outline'),
  'escalator': () => import('./icons/escalator'),
  'escalator_warning': () => import('./icons/escalator_warning'),
  'euro': () => import('./icons/euro'),
  'euro_symbol': () => import('./icons/euro_symbol'),
  'ev_station': () => import('./icons/ev_station'),
  'event': () => import('./icons/event'),
  'event_available': () => import('./icons/event_available'),
  'event_busy': () => import('./icons/event_busy'),
  'event_note': () => import('./icons/event_note'),
  'event_repeat': () => import('./icons/event_repeat'),
  'event_seat': () => import('./icons/event_seat'),
  'exit_to_app': () => import('./icons/exit_to_app'),
  'expand': () => import('./icons/expand'),
  'expand_circle_down': () => import('./icons/expand_circle_down'),
  'expand_less': () => import('./icons/expand_less'),
  'expand_more': () => import('./icons/expand_more'),
  'explicit': () => import('./icons/explicit'),
  'explore': () => import('./icons/explore'),
  'explore_off': () => import('./icons/explore_off'),
  'exposure': () => import('./icons/exposure'),
  'exposure_neg_1': () => import('./icons/exposure_neg_1'),
  'exposure_neg_2': () => import('./icons/exposure_neg_2'),
  'exposure_plus_1': () => import('./icons/exposure_plus_1'),
  'exposure_plus_2': () => import('./icons/exposure_plus_2'),
  'exposure_zero': () => import('./icons/exposure_zero'),
  'extension': () => import('./icons/extension'),
  'extension_off': () => import('./icons/extension_off'),
  'face': () => import('./icons/face'),
  'face_2': () => import('./icons/face_2'),
  'face_3': () => import('./icons/face_3'),
  'face_4': () => import('./icons/face_4'),
  'face_5': () => import('./icons/face_5'),
  'face_6': () => import('./icons/face_6'),
  'face_retouching_natural': () => import('./icons/face_retouching_natural'),
  'face_retouching_off': () => import('./icons/face_retouching_off'),
  'fact_check': () => import('./icons/fact_check'),
  'factory': () => import('./icons/factory'),
  'family_restroom': () => import('./icons/family_restroom'),
  'fast_forward': () => import('./icons/fast_forward'),
  'fast_rewind': () => import('./icons/fast_rewind'),
  'fastfood': () => import('./icons/fastfood'),
  'favorite': () => import('./icons/favorite'),
  'favorite_border': () => import('./icons/favorite_border'),
  'fax': () => import('./icons/fax'),
  'featured_play_list': () => import('./icons/featured_play_list'),
  'featured_video': () => import('./icons/featured_video'),
  'feed': () => import('./icons/feed'),
  'feedback': () => import('./icons/feedback'),
  'female': () => import('./icons/female'),
  'fence': () => import('./icons/fence'),
  'festival': () => import('./icons/festival'),
  'fiber_dvr': () => import('./icons/fiber_dvr'),
  'fiber_manual_record': () => import('./icons/fiber_manual_record'),
  'fiber_new': () => import('./icons/fiber_new'),
  'fiber_pin': () => import('./icons/fiber_pin'),
  'fiber_smart_record': () => import('./icons/fiber_smart_record'),
  'fifteenmp': () => import('./icons/fifteenmp'),
  'file_copy': () => import('./icons/file_copy'),
  'file_download': () => import('./icons/file_download'),
  'file_download_done': () => import('./icons/file_download_done'),
  'file_download_off': () => import('./icons/file_download_off'),
  'file_open': () => import('./icons/file_open'),
  'file_present': () => import('./icons/file_present'),
  'file_upload': () => import('./icons/file_upload'),
  'filter': () => import('./icons/filter'),
  'filter_1': () => import('./icons/filter_1'),
  'filter_2': () => import('./icons/filter_2'),
  'filter_3': () => import('./icons/filter_3'),
  'filter_4': () => import('./icons/filter_4'),
  'filter_5': () => import('./icons/filter_5'),
  'filter_6': () => import('./icons/filter_6'),
  'filter_7': () => import('./icons/filter_7'),
  'filter_8': () => import('./icons/filter_8'),
  'filter_9': () => import('./icons/filter_9'),
  'filter_9_plus': () => import('./icons/filter_9_plus'),
  'filter_alt': () => import('./icons/filter_alt'),
  'filter_alt_off': () => import('./icons/filter_alt_off'),
  'filter_b_and_w': () => import('./icons/filter_b_and_w'),
  'filter_center_focus': () => import('./icons/filter_center_focus'),
  'filter_drama': () => import('./icons/filter_drama'),
  'filter_frames': () => import('./icons/filter_frames'),
  'filter_hdr': () => import('./icons/filter_hdr'),
  'filter_list': () => import('./icons/filter_list'),
  'filter_list_off': () => import('./icons/filter_list_off'),
  'filter_none': () => import('./icons/filter_none'),
  'filter_tilt_shift': () => import('./icons/filter_tilt_shift'),
  'filter_vintage': () => import('./icons/filter_vintage'),
  'find_in_page': () => import('./icons/find_in_page'),
  'find_replace': () => import('./icons/find_replace'),
  'fingerprint': () => import('./icons/fingerprint'),
  'fire_extinguisher': () => import('./icons/fire_extinguisher'),
  'fire_hydrant_alt': () => import('./icons/fire_hydrant_alt'),
  'fire_truck': () => import('./icons/fire_truck'),
  'fireplace': () => import('./icons/fireplace'),
  'first_page': () => import('./icons/first_page'),
  'fit_screen': () => import('./icons/fit_screen'),
  'fitbit': () => import('./icons/fitbit'),
  'fitness_center': () => import('./icons/fitness_center'),
  'fiveg': () => import('./icons/fiveg'),
  'fivek': () => import('./icons/fivek'),
  'fivek_plus': () => import('./icons/fivek_plus'),
  'fivemp': () => import('./icons/fivemp'),
  'flag': () => import('./icons/flag'),
  'flag_circle': () => import('./icons/flag_circle'),
  'flaky': () => import('./icons/flaky'),
  'flare': () => import('./icons/flare'),
  'flash_auto': () => import('./icons/flash_auto'),
  'flash_off': () => import('./icons/flash_off'),
  'flash_on': () => import('./icons/flash_on'),
  'flashlight_off': () => import('./icons/flashlight_off'),
  'flashlight_on': () => import('./icons/flashlight_on'),
  'flatware': () => import('./icons/flatware'),
  'flight': () => import('./icons/flight'),
  'flight_class': () => import('./icons/flight_class'),
  'flight_land': () => import('./icons/flight_land'),
  'flight_takeoff': () => import('./icons/flight_takeoff'),
  'flip': () => import('./icons/flip'),
  'flip_camera_android': () => import('./icons/flip_camera_android'),
  'flip_camera_ios': () => import('./icons/flip_camera_ios'),
  'flip_to_back': () => import('./icons/flip_to_back'),
  'flip_to_front': () => import('./icons/flip_to_front'),
  'flood': () => import('./icons/flood'),
  'fluorescent': () => import('./icons/fluorescent'),
  'flutter_dash': () => import('./icons/flutter_dash'),
  'fmd_bad': () => import('./icons/fmd_bad'),
  'fmd_good': () => import('./icons/fmd_good'),
  'folder': () => import('./icons/folder'),
  'folder_copy': () => import('./icons/folder_copy'),
  'folder_delete': () => import('./icons/folder_delete'),
  'folder_off': () => import('./icons/folder_off'),
  'folder_open': () => import('./icons/folder_open'),
  'folder_shared': () => import('./icons/folder_shared'),
  'folder_special': () => import('./icons/folder_special'),
  'folder_zip': () => import('./icons/folder_zip'),
  'follow_the_signs': () => import('./icons/follow_the_signs'),
  'font_download': () => import('./icons/font_download'),
  'font_download_off': () => import('./icons/font_download_off'),
  'food_bank': () => import('./icons/food_bank'),
  'forest': () => import('./icons/forest'),
  'fork_left': () => import('./icons/fork_left'),
  'fork_right': () => import('./icons/fork_right'),
  'format_align_center': () => import('./icons/format_align_center'),
  'format_align_justify': () => import('./icons/format_align_justify'),
  'format_align_left': () => import('./icons/format_align_left'),
  'format_align_right': () => import('./icons/format_align_right'),
  'format_bold': () => import('./icons/format_bold'),
  'format_clear': () => import('./icons/format_clear'),
  'format_color_fill': () => import('./icons/format_color_fill'),
  'format_color_reset': () => import('./icons/format_color_reset'),
  'format_color_text': () => import('./icons/format_color_text'),
  'format_indent_decrease': () => import('./icons/format_indent_decrease'),
  'format_indent_increase': () => import('./icons/format_indent_increase'),
  'format_italic': () => import('./icons/format_italic'),
  'format_line_spacing': () => import('./icons/format_line_spacing'),
  'format_list_bulleted': () => import('./icons/format_list_bulleted'),
  'format_list_numbered': () => import('./icons/format_list_numbered'),
  'format_list_numbered_rtl': () => import('./icons/format_list_numbered_rtl'),
  'format_overline': () => import('./icons/format_overline'),
  'format_paint': () => import('./icons/format_paint'),
  'format_quote': () => import('./icons/format_quote'),
  'format_shapes': () => import('./icons/format_shapes'),
  'format_size': () => import('./icons/format_size'),
  'format_strikethrough': () => import('./icons/format_strikethrough'),
  'format_textdirection_l_to_r': () => import('./icons/format_textdirection_l_to_r'),
  'format_textdirection_r_to_l': () => import('./icons/format_textdirection_r_to_l'),
  'format_underlined': () => import('./icons/format_underlined'),
  'fort': () => import('./icons/fort'),
  'forum': () => import('./icons/forum'),
  'forward': () => import('./icons/forward'),
  'forward_10': () => import('./icons/forward_10'),
  'forward_30': () => import('./icons/forward_30'),
  'forward_5': () => import('./icons/forward_5'),
  'forward_to_inbox': () => import('./icons/forward_to_inbox'),
  'foundation': () => import('./icons/foundation'),
  'foureg_plus_mobiledata': () => import('./icons/foureg_plus_mobiledata'),
  'fourek': () => import('./icons/fourek'),
  'fourek_plus': () => import('./icons/fourek_plus'),
  'fourg_mobiledata': () => import('./icons/fourg_mobiledata'),
  'fourmp': () => import('./icons/fourmp'),
  'fourteenmp': () => import('./icons/fourteenmp'),
  'free_breakfast': () => import('./icons/free_breakfast'),
  'free_cancellation': () => import('./icons/free_cancellation'),
  'front_hand': () => import('./icons/front_hand'),
  'fullscreen': () => import('./icons/fullscreen'),
  'fullscreen_exit': () => import('./icons/fullscreen_exit'),
  'functions': () => import('./icons/functions'),
  'g_mobiledata': () => import('./icons/g_mobiledata'),
  'g_translate': () => import('./icons/g_translate'),
  'gamepad': () => import('./icons/gamepad'),
  'games': () => import('./icons/games'),
  'garage': () => import('./icons/garage'),
  'gas_meter': () => import('./icons/gas_meter'),
  'gavel': () => import('./icons/gavel'),
  'generating_tokens': () => import('./icons/generating_tokens'),
  'gesture': () => import('./icons/gesture'),
  'get_app': () => import('./icons/get_app'),
  'gif': () => import('./icons/gif'),
  'gif_box': () => import('./icons/gif_box'),
  'girl': () => import('./icons/girl'),
  'gite': () => import('./icons/gite'),
  'golf_course': () => import('./icons/golf_course'),
  'gpp_bad': () => import('./icons/gpp_bad'),
  'gpp_good': () => import('./icons/gpp_good'),
  'gpp_maybe': () => import('./icons/gpp_maybe'),
  'gps_fixed': () => import('./icons/gps_fixed'),
  'gps_not_fixed': () => import('./icons/gps_not_fixed'),
  'gps_off': () => import('./icons/gps_off'),
  'grade': () => import('./icons/grade'),
  'gradient': () => import('./icons/gradient'),
  'grading': () => import('./icons/grading'),
  'grain': () => import('./icons/grain'),
  'graphic_eq': () => import('./icons/graphic_eq'),
  'grass': () => import('./icons/grass'),
  'grid_3x3': () => import('./icons/grid_3x3'),
  'grid_4x4': () => import('./icons/grid_4x4'),
  'grid_goldenratio': () => import('./icons/grid_goldenratio'),
  'grid_off': () => import('./icons/grid_off'),
  'grid_on': () => import('./icons/grid_on'),
  'grid_view': () => import('./icons/grid_view'),
  'group': () => import('./icons/group'),
  'group_add': () => import('./icons/group_add'),
  'group_off': () => import('./icons/group_off'),
  'group_remove': () => import('./icons/group_remove'),
  'group_work': () => import('./icons/group_work'),
  'groups': () => import('./icons/groups'),
  'groups_2': () => import('./icons/groups_2'),
  'groups_3': () => import('./icons/groups_3'),
  'h_mobiledata': () => import('./icons/h_mobiledata'),
  'h_plus_mobiledata': () => import('./icons/h_plus_mobiledata'),
  'hail': () => import('./icons/hail'),
  'handshake': () => import('./icons/handshake'),
  'handyman': () => import('./icons/handyman'),
  'hardware': () => import('./icons/hardware'),
  'hd': () => import('./icons/hd'),
  'hdr_auto': () => import('./icons/hdr_auto'),
  'hdr_auto_select': () => import('./icons/hdr_auto_select'),
  'hdr_enhanced_select': () => import('./icons/hdr_enhanced_select'),
  'hdr_off': () => import('./icons/hdr_off'),
  'hdr_off_select': () => import('./icons/hdr_off_select'),
  'hdr_on': () => import('./icons/hdr_on'),
  'hdr_on_select': () => import('./icons/hdr_on_select'),
  'hdr_plus': () => import('./icons/hdr_plus'),
  'hdr_strong': () => import('./icons/hdr_strong'),
  'hdr_weak': () => import('./icons/hdr_weak'),
  'headphones': () => import('./icons/headphones'),
  'headphones_battery': () => import('./icons/headphones_battery'),
  'headset': () => import('./icons/headset'),
  'headset_mic': () => import('./icons/headset_mic'),
  'headset_off': () => import('./icons/headset_off'),
  'healing': () => import('./icons/healing'),
  'health_and_safety': () => import('./icons/health_and_safety'),
  'hearing': () => import('./icons/hearing'),
  'hearing_disabled': () => import('./icons/hearing_disabled'),
  'heart_broken': () => import('./icons/heart_broken'),
  'heat_pump': () => import('./icons/heat_pump'),
  'height': () => import('./icons/height'),
  'help': () => import('./icons/help'),
  'help_center': () => import('./icons/help_center'),
  'help_outline': () => import('./icons/help_outline'),
  'hevc': () => import('./icons/hevc'),
  'hexagon': () => import('./icons/hexagon'),
  'hide_image': () => import('./icons/hide_image'),
  'hide_source': () => import('./icons/hide_source'),
  'high_quality': () => import('./icons/high_quality'),
  'highlight': () => import('./icons/highlight'),
  'highlight_alt': () => import('./icons/highlight_alt'),
  'highlight_off': () => import('./icons/highlight_off'),
  'hiking': () => import('./icons/hiking'),
  'history': () => import('./icons/history'),
  'history_edu': () => import('./icons/history_edu'),
  'history_toggle_off': () => import('./icons/history_toggle_off'),
  'hive': () => import('./icons/hive'),
  'hls': () => import('./icons/hls'),
  'hls_off': () => import('./icons/hls_off'),
  'holiday_village': () => import('./icons/holiday_village'),
  'home': () => import('./icons/home'),
  'home_max': () => import('./icons/home_max'),
  'home_mini': () => import('./icons/home_mini'),
  'home_repair_service': () => import('./icons/home_repair_service'),
  'home_work': () => import('./icons/home_work'),
  'horizontal_distribute': () => import('./icons/horizontal_distribute'),
  'horizontal_rule': () => import('./icons/horizontal_rule'),
  'horizontal_split': () => import('./icons/horizontal_split'),
  'hot_tub': () => import('./icons/hot_tub'),
  'hotel': () => import('./icons/hotel'),
  'hotel_class': () => import('./icons/hotel_class'),
  'hourglass_bottom': () => import('./icons/hourglass_bottom'),
  'hourglass_disabled': () => import('./icons/hourglass_disabled'),
  'hourglass_empty': () => import('./icons/hourglass_empty'),
  'hourglass_full': () => import('./icons/hourglass_full'),
  'hourglass_top': () => import('./icons/hourglass_top'),
  'house': () => import('./icons/house'),
  'house_siding': () => import('./icons/house_siding'),
  'houseboat': () => import('./icons/houseboat'),
  'how_to_reg': () => import('./icons/how_to_reg'),
  'how_to_vote': () => import('./icons/how_to_vote'),
  'html': () => import('./icons/html'),
  'http': () => import('./icons/http'),
  'https': () => import('./icons/https'),
  'hub': () => import('./icons/hub'),
  'hvac': () => import('./icons/hvac'),
  'ice_skating': () => import('./icons/ice_skating'),
  'icecream': () => import('./icons/icecream'),
  'image': () => import('./icons/image'),
  'image_aspect_ratio': () => import('./icons/image_aspect_ratio'),
  'image_not_supported': () => import('./icons/image_not_supported'),
  'image_search': () => import('./icons/image_search'),
  'imagesearch_roller': () => import('./icons/imagesearch_roller'),
  'import_contacts': () => import('./icons/import_contacts'),
  'import_export': () => import('./icons/import_export'),
  'important_devices': () => import('./icons/important_devices'),
  'inbox': () => import('./icons/inbox'),
  'incomplete_circle': () => import('./icons/incomplete_circle'),
  'indeterminate_check_box': () => import('./icons/indeterminate_check_box'),
  'info': () => import('./icons/info'),
  'input': () => import('./icons/input'),
  'insert_chart': () => import('./icons/insert_chart'),
  'insert_chart_outlined': () => import('./icons/insert_chart_outlined'),
  'insert_comment': () => import('./icons/insert_comment'),
  'insert_drive_file': () => import('./icons/insert_drive_file'),
  'insert_emoticon': () => import('./icons/insert_emoticon'),
  'insert_invitation': () => import('./icons/insert_invitation'),
  'insert_link': () => import('./icons/insert_link'),
  'insert_page_break': () => import('./icons/insert_page_break'),
  'insert_photo': () => import('./icons/insert_photo'),
  'insights': () => import('./icons/insights'),
  'install_desktop': () => import('./icons/install_desktop'),
  'install_mobile': () => import('./icons/install_mobile'),
  'integration_instructions': () => import('./icons/integration_instructions'),
  'interests': () => import('./icons/interests'),
  'interpreter_mode': () => import('./icons/interpreter_mode'),
  'inventory': () => import('./icons/inventory'),
  'inventory_2': () => import('./icons/inventory_2'),
  'invert_colors': () => import('./icons/invert_colors'),
  'invert_colors_off': () => import('./icons/invert_colors_off'),
  'ios_share': () => import('./icons/ios_share'),
  'iron': () => import('./icons/iron'),
  'iso': () => import('./icons/iso'),
  'javascript': () => import('./icons/javascript'),
  'join_full': () => import('./icons/join_full'),
  'join_inner': () => import('./icons/join_inner'),
  'join_left': () => import('./icons/join_left'),
  'join_right': () => import('./icons/join_right'),
  'kayaking': () => import('./icons/kayaking'),
  'kebab_dining': () => import('./icons/kebab_dining'),
  'key': () => import('./icons/key'),
  'key_off': () => import('./icons/key_off'),
  'keyboard': () => import('./icons/keyboard'),
  'keyboard_alt': () => import('./icons/keyboard_alt'),
  'keyboard_arrow_down': () => import('./icons/keyboard_arrow_down'),
  'keyboard_arrow_left': () => import('./icons/keyboard_arrow_left'),
  'keyboard_arrow_right': () => import('./icons/keyboard_arrow_right'),
  'keyboard_arrow_up': () => import('./icons/keyboard_arrow_up'),
  'keyboard_backspace': () => import('./icons/keyboard_backspace'),
  'keyboard_capslock': () => import('./icons/keyboard_capslock'),
  'keyboard_command_key': () => import('./icons/keyboard_command_key'),
  'keyboard_control_key': () => import('./icons/keyboard_control_key'),
  'keyboard_double_arrow_down': () => import('./icons/keyboard_double_arrow_down'),
  'keyboard_double_arrow_left': () => import('./icons/keyboard_double_arrow_left'),
  'keyboard_double_arrow_right': () => import('./icons/keyboard_double_arrow_right'),
  'keyboard_double_arrow_up': () => import('./icons/keyboard_double_arrow_up'),
  'keyboard_hide': () => import('./icons/keyboard_hide'),
  'keyboard_option_key': () => import('./icons/keyboard_option_key'),
  'keyboard_return': () => import('./icons/keyboard_return'),
  'keyboard_tab': () => import('./icons/keyboard_tab'),
  'keyboard_voice': () => import('./icons/keyboard_voice'),
  'king_bed': () => import('./icons/king_bed'),
  'kitchen': () => import('./icons/kitchen'),
  'kitesurfing': () => import('./icons/kitesurfing'),
  'label': () => import('./icons/label'),
  'label_important': () => import('./icons/label_important'),
  'label_off': () => import('./icons/label_off'),
  'lan': () => import('./icons/lan'),
  'landscape': () => import('./icons/landscape'),
  'landslide': () => import('./icons/landslide'),
  'language': () => import('./icons/language'),
  'laptop': () => import('./icons/laptop'),
  'laptop_chromebook': () => import('./icons/laptop_chromebook'),
  'laptop_mac': () => import('./icons/laptop_mac'),
  'laptop_windows': () => import('./icons/laptop_windows'),
  'last_page': () => import('./icons/last_page'),
  'launch': () => import('./icons/launch'),
  'layers': () => import('./icons/layers'),
  'layers_clear': () => import('./icons/layers_clear'),
  'leaderboard': () => import('./icons/leaderboard'),
  'leak_add': () => import('./icons/leak_add'),
  'leak_remove': () => import('./icons/leak_remove'),
  'legend_toggle': () => import('./icons/legend_toggle'),
  'lens': () => import('./icons/lens'),
  'lens_blur': () => import('./icons/lens_blur'),
  'library_add': () => import('./icons/library_add'),
  'library_add_check': () => import('./icons/library_add_check'),
  'library_books': () => import('./icons/library_books'),
  'library_music': () => import('./icons/library_music'),
  'light': () => import('./icons/light'),
  'light_mode': () => import('./icons/light_mode'),
  'lightbulb': () => import('./icons/lightbulb'),
  'lightbulb_circle': () => import('./icons/lightbulb_circle'),
  'line_axis': () => import('./icons/line_axis'),
  'line_style': () => import('./icons/line_style'),
  'line_weight': () => import('./icons/line_weight'),
  'linear_scale': () => import('./icons/linear_scale'),
  'link': () => import('./icons/link'),
  'link_off': () => import('./icons/link_off'),
  'linked_camera': () => import('./icons/linked_camera'),
  'liquor': () => import('./icons/liquor'),
  'list': () => import('./icons/list'),
  'list_alt': () => import('./icons/list_alt'),
  'live_help': () => import('./icons/live_help'),
  'live_tv': () => import('./icons/live_tv'),
  'living': () => import('./icons/living'),
  'local_activity': () => import('./icons/local_activity'),
  'local_airport': () => import('./icons/local_airport'),
  'local_atm': () => import('./icons/local_atm'),
  'local_bar': () => import('./icons/local_bar'),
  'local_cafe': () => import('./icons/local_cafe'),
  'local_car_wash': () => import('./icons/local_car_wash'),
  'local_convenience_store': () => import('./icons/local_convenience_store'),
  'local_dining': () => import('./icons/local_dining'),
  'local_drink': () => import('./icons/local_drink'),
  'local_fire_department': () => import('./icons/local_fire_department'),
  'local_florist': () => import('./icons/local_florist'),
  'local_gas_station': () => import('./icons/local_gas_station'),
  'local_grocery_store': () => import('./icons/local_grocery_store'),
  'local_hospital': () => import('./icons/local_hospital'),
  'local_hotel': () => import('./icons/local_hotel'),
  'local_laundry_service': () => import('./icons/local_laundry_service'),
  'local_library': () => import('./icons/local_library'),
  'local_mall': () => import('./icons/local_mall'),
  'local_movies': () => import('./icons/local_movies'),
  'local_offer': () => import('./icons/local_offer'),
  'local_parking': () => import('./icons/local_parking'),
  'local_pharmacy': () => import('./icons/local_pharmacy'),
  'local_phone': () => import('./icons/local_phone'),
  'local_pizza': () => import('./icons/local_pizza'),
  'local_play': () => import('./icons/local_play'),
  'local_police': () => import('./icons/local_police'),
  'local_post_office': () => import('./icons/local_post_office'),
  'local_printshop': () => import('./icons/local_printshop'),
  'local_see': () => import('./icons/local_see'),
  'local_shipping': () => import('./icons/local_shipping'),
  'local_taxi': () => import('./icons/local_taxi'),
  'location_city': () => import('./icons/location_city'),
  'location_disabled': () => import('./icons/location_disabled'),
  'location_off': () => import('./icons/location_off'),
  'location_on': () => import('./icons/location_on'),
  'location_searching': () => import('./icons/location_searching'),
  'lock': () => import('./icons/lock'),
  'lock_clock': () => import('./icons/lock_clock'),
  'lock_open': () => import('./icons/lock_open'),
  'lock_person': () => import('./icons/lock_person'),
  'lock_reset': () => import('./icons/lock_reset'),
  'login': () => import('./icons/login'),
  'logo_dev': () => import('./icons/logo_dev'),
  'logout': () => import('./icons/logout'),
  'looks': () => import('./icons/looks'),
  'looks_3': () => import('./icons/looks_3'),
  'looks_4': () => import('./icons/looks_4'),
  'looks_5': () => import('./icons/looks_5'),
  'looks_6': () => import('./icons/looks_6'),
  'looks_one': () => import('./icons/looks_one'),
  'looks_two': () => import('./icons/looks_two'),
  'loop': () => import('./icons/loop'),
  'loupe': () => import('./icons/loupe'),
  'low_priority': () => import('./icons/low_priority'),
  'loyalty': () => import('./icons/loyalty'),
  'lte_mobiledata': () => import('./icons/lte_mobiledata'),
  'lte_plus_mobiledata': () => import('./icons/lte_plus_mobiledata'),
  'luggage': () => import('./icons/luggage'),
  'lunch_dining': () => import('./icons/lunch_dining'),
  'lyrics': () => import('./icons/lyrics'),
  'macro_off': () => import('./icons/macro_off'),
  'mail': () => import('./icons/mail'),
  'mail_lock': () => import('./icons/mail_lock'),
  'mail_outline': () => import('./icons/mail_outline'),
  'male': () => import('./icons/male'),
  'man': () => import('./icons/man'),
  'man_2': () => import('./icons/man_2'),
  'man_3': () => import('./icons/man_3'),
  'man_4': () => import('./icons/man_4'),
  'manage_accounts': () => import('./icons/manage_accounts'),
  'manage_history': () => import('./icons/manage_history'),
  'manage_search': () => import('./icons/manage_search'),
  'map': () => import('./icons/map'),
  'maps_home_work': () => import('./icons/maps_home_work'),
  'maps_ugc': () => import('./icons/maps_ugc'),
  'margin': () => import('./icons/margin'),
  'mark_as_unread': () => import('./icons/mark_as_unread'),
  'mark_chat_read': () => import('./icons/mark_chat_read'),
  'mark_chat_unread': () => import('./icons/mark_chat_unread'),
  'mark_email_read': () => import('./icons/mark_email_read'),
  'mark_email_unread': () => import('./icons/mark_email_unread'),
  'mark_unread_chat_alt': () => import('./icons/mark_unread_chat_alt'),
  'markunread': () => import('./icons/markunread'),
  'markunread_mailbox': () => import('./icons/markunread_mailbox'),
  'masks': () => import('./icons/masks'),
  'maximize': () => import('./icons/maximize'),
  'mazaya': () => import('./icons/mazaya'),
  'media_bluetooth_off': () => import('./icons/media_bluetooth_off'),
  'media_bluetooth_on': () => import('./icons/media_bluetooth_on'),
  'mediation': () => import('./icons/mediation'),
  'medical_information': () => import('./icons/medical_information'),
  'medical_services': () => import('./icons/medical_services'),
  'medication': () => import('./icons/medication'),
  'medication_liquid': () => import('./icons/medication_liquid'),
  'meeting_room': () => import('./icons/meeting_room'),
  'memory': () => import('./icons/memory'),
  'menu': () => import('./icons/menu'),
  'menu_book': () => import('./icons/menu_book'),
  'menu_open': () => import('./icons/menu_open'),
  'merge': () => import('./icons/merge'),
  'merge_type': () => import('./icons/merge_type'),
  'message': () => import('./icons/message'),
  'mic': () => import('./icons/mic'),
  'mic_external_off': () => import('./icons/mic_external_off'),
  'mic_external_on': () => import('./icons/mic_external_on'),
  'mic_none': () => import('./icons/mic_none'),
  'mic_off': () => import('./icons/mic_off'),
  'microwave': () => import('./icons/microwave'),
  'military_tech': () => import('./icons/military_tech'),
  'minimize': () => import('./icons/minimize'),
  'minor_crash': () => import('./icons/minor_crash'),
  'miscellaneous_services': () => import('./icons/miscellaneous_services'),
  'missed_video_call': () => import('./icons/missed_video_call'),
  'mms': () => import('./icons/mms'),
  'mobile_friendly': () => import('./icons/mobile_friendly'),
  'mobile_off': () => import('./icons/mobile_off'),
  'mobile_screen_share': () => import('./icons/mobile_screen_share'),
  'mobiledata_off': () => import('./icons/mobiledata_off'),
  'mode': () => import('./icons/mode'),
  'mode_comment': () => import('./icons/mode_comment'),
  'mode_edit': () => import('./icons/mode_edit'),
  'mode_edit_outline': () => import('./icons/mode_edit_outline'),
  'mode_fan_off': () => import('./icons/mode_fan_off'),
  'mode_night': () => import('./icons/mode_night'),
  'mode_of_travel': () => import('./icons/mode_of_travel'),
  'mode_standby': () => import('./icons/mode_standby'),
  'model_training': () => import('./icons/model_training'),
  'monetization_on': () => import('./icons/monetization_on'),
  'money': () => import('./icons/money'),
  'money_off': () => import('./icons/money_off'),
  'money_off_csred': () => import('./icons/money_off_csred'),
  'monitor': () => import('./icons/monitor'),
  'monitor_heart': () => import('./icons/monitor_heart'),
  'monitor_weight': () => import('./icons/monitor_weight'),
  'monochrome_photos': () => import('./icons/monochrome_photos'),
  'mood': () => import('./icons/mood'),
  'mood_bad': () => import('./icons/mood_bad'),
  'moped': () => import('./icons/moped'),
  'more': () => import('./icons/more'),
  'more_horiz': () => import('./icons/more_horiz'),
  'more_time': () => import('./icons/more_time'),
  'more_vert': () => import('./icons/more_vert'),
  'mosque': () => import('./icons/mosque'),
  'motion_photos_auto': () => import('./icons/motion_photos_auto'),
  'motion_photos_off': () => import('./icons/motion_photos_off'),
  'motion_photos_on': () => import('./icons/motion_photos_on'),
  'motion_photos_pause': () => import('./icons/motion_photos_pause'),
  'motion_photos_paused': () => import('./icons/motion_photos_paused'),
  'mouse': () => import('./icons/mouse'),
  'move_down': () => import('./icons/move_down'),
  'move_to_inbox': () => import('./icons/move_to_inbox'),
  'move_up': () => import('./icons/move_up'),
  'movie': () => import('./icons/movie'),
  'movie_creation': () => import('./icons/movie_creation'),
  'movie_filter': () => import('./icons/movie_filter'),
  'moving': () => import('./icons/moving'),
  'mp': () => import('./icons/mp'),
  'multiline_chart': () => import('./icons/multiline_chart'),
  'multiple_stop': () => import('./icons/multiple_stop'),
  'museum': () => import('./icons/museum'),
  'music_note': () => import('./icons/music_note'),
  'music_off': () => import('./icons/music_off'),
  'music_video': () => import('./icons/music_video'),
  'my_location': () => import('./icons/my_location'),
  'nat': () => import('./icons/nat'),
  'nature': () => import('./icons/nature'),
  'nature_people': () => import('./icons/nature_people'),
  'navigate_before': () => import('./icons/navigate_before'),
  'navigate_next': () => import('./icons/navigate_next'),
  'navigation': () => import('./icons/navigation'),
  'near_me': () => import('./icons/near_me'),
  'near_me_disabled': () => import('./icons/near_me_disabled'),
  'nearby_error': () => import('./icons/nearby_error'),
  'nearby_off': () => import('./icons/nearby_off'),
  'nest_cam_wired_stand': () => import('./icons/nest_cam_wired_stand'),
  'network_cell': () => import('./icons/network_cell'),
  'network_check': () => import('./icons/network_check'),
  'network_locked': () => import('./icons/network_locked'),
  'network_ping': () => import('./icons/network_ping'),
  'network_wifi': () => import('./icons/network_wifi'),
  'network_wifi_1_bar': () => import('./icons/network_wifi_1_bar'),
  'network_wifi_2_bar': () => import('./icons/network_wifi_2_bar'),
  'network_wifi_3_bar': () => import('./icons/network_wifi_3_bar'),
  'new_label': () => import('./icons/new_label'),
  'new_releases': () => import('./icons/new_releases'),
  'newspaper': () => import('./icons/newspaper'),
  'next_plan': () => import('./icons/next_plan'),
  'next_week': () => import('./icons/next_week'),
  'nfc': () => import('./icons/nfc'),
  'night_shelter': () => import('./icons/night_shelter'),
  'nightlife': () => import('./icons/nightlife'),
  'nightlight': () => import('./icons/nightlight'),
  'nightlight_round': () => import('./icons/nightlight_round'),
  'nights_stay': () => import('./icons/nights_stay'),
  'ninek': () => import('./icons/ninek'),
  'ninek_plus': () => import('./icons/ninek_plus'),
  'ninemp': () => import('./icons/ninemp'),
  'ninteenmp': () => import('./icons/ninteenmp'),
  'no_accounts': () => import('./icons/no_accounts'),
  'no_adult_content': () => import('./icons/no_adult_content'),
  'no_backpack': () => import('./icons/no_backpack'),
  'no_cell': () => import('./icons/no_cell'),
  'no_crash': () => import('./icons/no_crash'),
  'no_drinks': () => import('./icons/no_drinks'),
  'no_encryption': () => import('./icons/no_encryption'),
  'no_encryption_gmailerrorred': () => import('./icons/no_encryption_gmailerrorred'),
  'no_flash': () => import('./icons/no_flash'),
  'no_food': () => import('./icons/no_food'),
  'no_luggage': () => import('./icons/no_luggage'),
  'no_meals': () => import('./icons/no_meals'),
  'no_meeting_room': () => import('./icons/no_meeting_room'),
  'no_photography': () => import('./icons/no_photography'),
  'no_sim': () => import('./icons/no_sim'),
  'no_stroller': () => import('./icons/no_stroller'),
  'no_transfer': () => import('./icons/no_transfer'),
  'noise_aware': () => import('./icons/noise_aware'),
  'noise_control_off': () => import('./icons/noise_control_off'),
  'nordic_walking': () => import('./icons/nordic_walking'),
  'north': () => import('./icons/north'),
  'north_east': () => import('./icons/north_east'),
  'north_west': () => import('./icons/north_west'),
  'not_accessible': () => import('./icons/not_accessible'),
  'not_interested': () => import('./icons/not_interested'),
  'not_listed_location': () => import('./icons/not_listed_location'),
  'not_started': () => import('./icons/not_started'),
  'note': () => import('./icons/note'),
  'note_add': () => import('./icons/note_add'),
  'note_alt': () => import('./icons/note_alt'),
  'notes': () => import('./icons/notes'),
  'notification_add': () => import('./icons/notification_add'),
  'notification_important': () => import('./icons/notification_important'),
  'notification_settings': () => import('./icons/notification_settings'),
  'notifications': () => import('./icons/notifications'),
  'notifications_active': () => import('./icons/notifications_active'),
  'notifications_none': () => import('./icons/notifications_none'),
  'notifications_off': () => import('./icons/notifications_off'),
  'notifications_paused': () => import('./icons/notifications_paused'),
  'numbers': () => import('./icons/numbers'),
  'offline_bolt': () => import('./icons/offline_bolt'),
  'offline_pin': () => import('./icons/offline_pin'),
  'offline_share': () => import('./icons/offline_share'),
  'oil_barrel': () => import('./icons/oil_barrel'),
  'on_device_training': () => import('./icons/on_device_training'),
  'ondemand_video': () => import('./icons/ondemand_video'),
  'onek': () => import('./icons/onek'),
  'onek_plus': () => import('./icons/onek_plus'),
  'onetwothree': () => import('./icons/onetwothree'),
  'onex_mobiledata': () => import('./icons/onex_mobiledata'),
  'online_prediction': () => import('./icons/online_prediction'),
  'opacity': () => import('./icons/opacity'),
  'open_in_browser': () => import('./icons/open_in_browser'),
  'open_in_full': () => import('./icons/open_in_full'),
  'open_in_new': () => import('./icons/open_in_new'),
  'open_in_new_off': () => import('./icons/open_in_new_off'),
  'open_with': () => import('./icons/open_with'),
  'other_houses': () => import('./icons/other_houses'),
  'outbound': () => import('./icons/outbound'),
  'outbox': () => import('./icons/outbox'),
  'outdoor_grill': () => import('./icons/outdoor_grill'),
  'outlet': () => import('./icons/outlet'),
  'outlined_flag': () => import('./icons/outlined_flag'),
  'output': () => import('./icons/output'),
  'padding': () => import('./icons/padding'),
  'pages': () => import('./icons/pages'),
  'pageview': () => import('./icons/pageview'),
  'paid': () => import('./icons/paid'),
  'palette': () => import('./icons/palette'),
  'pan_tool': () => import('./icons/pan_tool'),
  'pan_tool_alt': () => import('./icons/pan_tool_alt'),
  'panorama': () => import('./icons/panorama'),
  'panorama_fish_eye': () => import('./icons/panorama_fish_eye'),
  'panorama_horizontal': () => import('./icons/panorama_horizontal'),
  'panorama_horizontal_select': () => import('./icons/panorama_horizontal_select'),
  'panorama_photosphere': () => import('./icons/panorama_photosphere'),
  'panorama_photosphere_select': () => import('./icons/panorama_photosphere_select'),
  'panorama_vertical': () => import('./icons/panorama_vertical'),
  'panorama_vertical_select': () => import('./icons/panorama_vertical_select'),
  'panorama_wide_angle': () => import('./icons/panorama_wide_angle'),
  'panorama_wide_angle_select': () => import('./icons/panorama_wide_angle_select'),
  'paragliding': () => import('./icons/paragliding'),
  'park': () => import('./icons/park'),
  'party_mode': () => import('./icons/party_mode'),
  'password': () => import('./icons/password'),
  'pattern': () => import('./icons/pattern'),
  'pause': () => import('./icons/pause'),
  'pause_circle': () => import('./icons/pause_circle'),
  'pause_circle_filled': () => import('./icons/pause_circle_filled'),
  'pause_circle_outline': () => import('./icons/pause_circle_outline'),
  'pause_presentation': () => import('./icons/pause_presentation'),
  'payment': () => import('./icons/payment'),
  'payments': () => import('./icons/payments'),
  'pedal_bike': () => import('./icons/pedal_bike'),
  'pending': () => import('./icons/pending'),
  'pending_actions': () => import('./icons/pending_actions'),
  'pentagon': () => import('./icons/pentagon'),
  'people': () => import('./icons/people'),
  'people_alt': () => import('./icons/people_alt'),
  'people_outline': () => import('./icons/people_outline'),
  'percent': () => import('./icons/percent'),
  'perm_camera_mic': () => import('./icons/perm_camera_mic'),
  'perm_contact_calendar': () => import('./icons/perm_contact_calendar'),
  'perm_data_setting': () => import('./icons/perm_data_setting'),
  'perm_device_information': () => import('./icons/perm_device_information'),
  'perm_identity': () => import('./icons/perm_identity'),
  'perm_media': () => import('./icons/perm_media'),
  'perm_phone_msg': () => import('./icons/perm_phone_msg'),
  'perm_scan_wifi': () => import('./icons/perm_scan_wifi'),
  'person': () => import('./icons/person'),
  'person_2': () => import('./icons/person_2'),
  'person_3': () => import('./icons/person_3'),
  'person_4': () => import('./icons/person_4'),
  'person_add': () => import('./icons/person_add'),
  'person_add_alt': () => import('./icons/person_add_alt'),
  'person_add_alt_1': () => import('./icons/person_add_alt_1'),
  'person_add_disabled': () => import('./icons/person_add_disabled'),
  'person_off': () => import('./icons/person_off'),
  'person_outline': () => import('./icons/person_outline'),
  'person_pin': () => import('./icons/person_pin'),
  'person_pin_circle': () => import('./icons/person_pin_circle'),
  'person_remove': () => import('./icons/person_remove'),
  'person_remove_alt_1': () => import('./icons/person_remove_alt_1'),
  'person_search': () => import('./icons/person_search'),
  'personal_injury': () => import('./icons/personal_injury'),
  'personal_video': () => import('./icons/personal_video'),
  'pest_control': () => import('./icons/pest_control'),
  'pest_control_rodent': () => import('./icons/pest_control_rodent'),
  'pets': () => import('./icons/pets'),
  'phishing': () => import('./icons/phishing'),
  'phone': () => import('./icons/phone'),
  'phone_android': () => import('./icons/phone_android'),
  'phone_bluetooth_speaker': () => import('./icons/phone_bluetooth_speaker'),
  'phone_callback': () => import('./icons/phone_callback'),
  'phone_disabled': () => import('./icons/phone_disabled'),
  'phone_enabled': () => import('./icons/phone_enabled'),
  'phone_forwarded': () => import('./icons/phone_forwarded'),
  'phone_iphone': () => import('./icons/phone_iphone'),
  'phone_locked': () => import('./icons/phone_locked'),
  'phone_missed': () => import('./icons/phone_missed'),
  'phone_paused': () => import('./icons/phone_paused'),
  'phonelink': () => import('./icons/phonelink'),
  'phonelink_erase': () => import('./icons/phonelink_erase'),
  'phonelink_lock': () => import('./icons/phonelink_lock'),
  'phonelink_off': () => import('./icons/phonelink_off'),
  'phonelink_ring': () => import('./icons/phonelink_ring'),
  'phonelink_setup': () => import('./icons/phonelink_setup'),
  'photo': () => import('./icons/photo'),
  'photo_album': () => import('./icons/photo_album'),
  'photo_camera': () => import('./icons/photo_camera'),
  'photo_camera_back': () => import('./icons/photo_camera_back'),
  'photo_camera_front': () => import('./icons/photo_camera_front'),
  'photo_filter': () => import('./icons/photo_filter'),
  'photo_library': () => import('./icons/photo_library'),
  'photo_size_select_actual': () => import('./icons/photo_size_select_actual'),
  'photo_size_select_large': () => import('./icons/photo_size_select_large'),
  'photo_size_select_small': () => import('./icons/photo_size_select_small'),
  'php': () => import('./icons/php'),
  'piano': () => import('./icons/piano'),
  'piano_off': () => import('./icons/piano_off'),
  'picture_as_pdf': () => import('./icons/picture_as_pdf'),
  'picture_in_picture': () => import('./icons/picture_in_picture'),
  'picture_in_picture_alt': () => import('./icons/picture_in_picture_alt'),
  'pie_chart': () => import('./icons/pie_chart'),
  'pie_chart_outline': () => import('./icons/pie_chart_outline'),
  'pin': () => import('./icons/pin'),
  'pin_drop': () => import('./icons/pin_drop'),
  'pin_end': () => import('./icons/pin_end'),
  'pin_invoke': () => import('./icons/pin_invoke'),
  'pinch': () => import('./icons/pinch'),
  'pivot_table_chart': () => import('./icons/pivot_table_chart'),
  'pix': () => import('./icons/pix'),
  'place': () => import('./icons/place'),
  'plagiarism': () => import('./icons/plagiarism'),
  'play_arrow': () => import('./icons/play_arrow'),
  'play_circle': () => import('./icons/play_circle'),
  'play_circle_filled': () => import('./icons/play_circle_filled'),
  'play_circle_outline': () => import('./icons/play_circle_outline'),
  'play_disabled': () => import('./icons/play_disabled'),
  'play_for_work': () => import('./icons/play_for_work'),
  'play_lesson': () => import('./icons/play_lesson'),
  'playlist_add': () => import('./icons/playlist_add'),
  'playlist_add_check': () => import('./icons/playlist_add_check'),
  'playlist_add_check_circle': () => import('./icons/playlist_add_check_circle'),
  'playlist_add_circle': () => import('./icons/playlist_add_circle'),
  'playlist_play': () => import('./icons/playlist_play'),
  'playlist_remove': () => import('./icons/playlist_remove'),
  'plumbing': () => import('./icons/plumbing'),
  'plus_one': () => import('./icons/plus_one'),
  'podcasts': () => import('./icons/podcasts'),
  'point_of_sale': () => import('./icons/point_of_sale'),
  'policy': () => import('./icons/policy'),
  'poll': () => import('./icons/poll'),
  'polyline': () => import('./icons/polyline'),
  'polymer': () => import('./icons/polymer'),
  'pool': () => import('./icons/pool'),
  'portable_wifi_off': () => import('./icons/portable_wifi_off'),
  'portrait': () => import('./icons/portrait'),
  'post_add': () => import('./icons/post_add'),
  'power': () => import('./icons/power'),
  'power_input': () => import('./icons/power_input'),
  'power_off': () => import('./icons/power_off'),
  'power_settings_new': () => import('./icons/power_settings_new'),
  'precision_manufacturing': () => import('./icons/precision_manufacturing'),
  'pregnant_woman': () => import('./icons/pregnant_woman'),
  'present_to_all': () => import('./icons/present_to_all'),
  'preview': () => import('./icons/preview'),
  'price_change': () => import('./icons/price_change'),
  'price_check': () => import('./icons/price_check'),
  'print': () => import('./icons/print'),
  'print_disabled': () => import('./icons/print_disabled'),
  'priority_high': () => import('./icons/priority_high'),
  'privacy_tip': () => import('./icons/privacy_tip'),
  'private_connectivity': () => import('./icons/private_connectivity'),
  'production_quantity_limits': () => import('./icons/production_quantity_limits'),
  'propane': () => import('./icons/propane'),
  'propane_tank': () => import('./icons/propane_tank'),
  'psychology': () => import('./icons/psychology'),
  'psychology_alt': () => import('./icons/psychology_alt'),
  'public': () => import('./icons/public'),
  'public_off': () => import('./icons/public_off'),
  'publish': () => import('./icons/publish'),
  'published_with_changes': () => import('./icons/published_with_changes'),
  'punch_clock': () => import('./icons/punch_clock'),
  'push_pin': () => import('./icons/push_pin'),
  'qr_code': () => import('./icons/qr_code'),
  'qr_code_2': () => import('./icons/qr_code_2'),
  'qr_code_scanner': () => import('./icons/qr_code_scanner'),
  'query_builder': () => import('./icons/query_builder'),
  'query_stats': () => import('./icons/query_stats'),
  'question_answer': () => import('./icons/question_answer'),
  'question_mark': () => import('./icons/question_mark'),
  'queue': () => import('./icons/queue'),
  'queue_music': () => import('./icons/queue_music'),
  'queue_play_next': () => import('./icons/queue_play_next'),
  'quickreply': () => import('./icons/quickreply'),
  'quiz': () => import('./icons/quiz'),
  'r_mobiledata': () => import('./icons/r_mobiledata'),
  'radar': () => import('./icons/radar'),
  'radio': () => import('./icons/radio'),
  'radio_button_checked': () => import('./icons/radio_button_checked'),
  'radio_button_unchecked': () => import('./icons/radio_button_unchecked'),
  'railway_alert': () => import('./icons/railway_alert'),
  'ramen_dining': () => import('./icons/ramen_dining'),
  'ramp_left': () => import('./icons/ramp_left'),
  'ramp_right': () => import('./icons/ramp_right'),
  'rate_review': () => import('./icons/rate_review'),
  'raw_off': () => import('./icons/raw_off'),
  'raw_on': () => import('./icons/raw_on'),
  'read_more': () => import('./icons/read_more'),
  'real_estate_agent': () => import('./icons/real_estate_agent'),
  'receipt': () => import('./icons/receipt'),
  'receipt_long': () => import('./icons/receipt_long'),
  'recent_actors': () => import('./icons/recent_actors'),
  'recommend': () => import('./icons/recommend'),
  'record_voice_over': () => import('./icons/record_voice_over'),
  'rectangle': () => import('./icons/rectangle'),
  'recycling': () => import('./icons/recycling'),
  'redeem': () => import('./icons/redeem'),
  'redo': () => import('./icons/redo'),
  'reduce_capacity': () => import('./icons/reduce_capacity'),
  'refresh': () => import('./icons/refresh'),
  'remember_me': () => import('./icons/remember_me'),
  'remove': () => import('./icons/remove'),
  'remove_circle': () => import('./icons/remove_circle'),
  'remove_circle_outline': () => import('./icons/remove_circle_outline'),
  'remove_done': () => import('./icons/remove_done'),
  'remove_from_queue': () => import('./icons/remove_from_queue'),
  'remove_moderator': () => import('./icons/remove_moderator'),
  'remove_red_eye': () => import('./icons/remove_red_eye'),
  'remove_road': () => import('./icons/remove_road'),
  'remove_shopping_cart': () => import('./icons/remove_shopping_cart'),
  'reorder': () => import('./icons/reorder'),
  'repartition': () => import('./icons/repartition'),
  'repeat': () => import('./icons/repeat'),
  'repeat_on': () => import('./icons/repeat_on'),
  'repeat_one': () => import('./icons/repeat_one'),
  'repeat_one_on': () => import('./icons/repeat_one_on'),
  'replay': () => import('./icons/replay'),
  'replay_10': () => import('./icons/replay_10'),
  'replay_30': () => import('./icons/replay_30'),
  'replay_5': () => import('./icons/replay_5'),
  'replay_circle_filled': () => import('./icons/replay_circle_filled'),
  'reply': () => import('./icons/reply'),
  'reply_all': () => import('./icons/reply_all'),
  'report': () => import('./icons/report'),
  'report_gmailerrorred': () => import('./icons/report_gmailerrorred'),
  'report_off': () => import('./icons/report_off'),
  'report_problem': () => import('./icons/report_problem'),
  'request_page': () => import('./icons/request_page'),
  'request_quote': () => import('./icons/request_quote'),
  'reset_tv': () => import('./icons/reset_tv'),
  'restart_alt': () => import('./icons/restart_alt'),
  'restaurant': () => import('./icons/restaurant'),
  'restaurant_menu': () => import('./icons/restaurant_menu'),
  'restore': () => import('./icons/restore'),
  'restore_from_trash': () => import('./icons/restore_from_trash'),
  'restore_page': () => import('./icons/restore_page'),
  'reviews': () => import('./icons/reviews'),
  'rice_bowl': () => import('./icons/rice_bowl'),
  'ring_volume': () => import('./icons/ring_volume'),
  'riyal': () => import('./icons/riyal'),
  'rocket': () => import('./icons/rocket'),
  'rocket_launch': () => import('./icons/rocket_launch'),
  'roller_shades': () => import('./icons/roller_shades'),
  'roller_shades_closed': () => import('./icons/roller_shades_closed'),
  'roller_skating': () => import('./icons/roller_skating'),
  'roofing': () => import('./icons/roofing'),
  'room': () => import('./icons/room'),
  'room_preferences': () => import('./icons/room_preferences'),
  'room_service': () => import('./icons/room_service'),
  'rotate': () => import('./icons/rotate'),
  'rotate_90_degrees_ccw': () => import('./icons/rotate_90_degrees_ccw'),
  'rotate_90_degrees_cw': () => import('./icons/rotate_90_degrees_cw'),
  'rotate_left': () => import('./icons/rotate_left'),
  'rotate_right': () => import('./icons/rotate_right'),
  'roundabout_left': () => import('./icons/roundabout_left'),
  'roundabout_right': () => import('./icons/roundabout_right'),
  'rounded_corner': () => import('./icons/rounded_corner'),
  'route': () => import('./icons/route'),
  'router': () => import('./icons/router'),
  'rowing': () => import('./icons/rowing'),
  'rss_feed': () => import('./icons/rss_feed'),
  'rsvp': () => import('./icons/rsvp'),
  'rtt': () => import('./icons/rtt'),
  'rule': () => import('./icons/rule'),
  'rule_folder': () => import('./icons/rule_folder'),
  'run_circle': () => import('./icons/run_circle'),
  'running_with_errors': () => import('./icons/running_with_errors'),
  'rv_hookup': () => import('./icons/rv_hookup'),
  'safety_check': () => import('./icons/safety_check'),
  'safety_divider': () => import('./icons/safety_divider'),
  'sailing': () => import('./icons/sailing'),
  'sanitizer': () => import('./icons/sanitizer'),
  'satellite': () => import('./icons/satellite'),
  'satellite_alt': () => import('./icons/satellite_alt'),
  'save': () => import('./icons/save'),
  'save_alt': () => import('./icons/save_alt'),
  'save_as': () => import('./icons/save_as'),
  'saved_search': () => import('./icons/saved_search'),
  'savings': () => import('./icons/savings'),
  'scale': () => import('./icons/scale'),
  'scanner': () => import('./icons/scanner'),
  'scatter_plot': () => import('./icons/scatter_plot'),
  'schedule': () => import('./icons/schedule'),
  'schedule_send': () => import('./icons/schedule_send'),
  'schema': () => import('./icons/schema'),
  'school': () => import('./icons/school'),
  'science': () => import('./icons/science'),
  'score': () => import('./icons/score'),
  'scoreboard': () => import('./icons/scoreboard'),
  'screen_lock_landscape': () => import('./icons/screen_lock_landscape'),
  'screen_lock_portrait': () => import('./icons/screen_lock_portrait'),
  'screen_lock_rotation': () => import('./icons/screen_lock_rotation'),
  'screen_rotation': () => import('./icons/screen_rotation'),
  'screen_rotation_alt': () => import('./icons/screen_rotation_alt'),
  'screen_search_desktop': () => import('./icons/screen_search_desktop'),
  'screen_share': () => import('./icons/screen_share'),
  'screenshot': () => import('./icons/screenshot'),
  'screenshot_monitor': () => import('./icons/screenshot_monitor'),
  'scuba_diving': () => import('./icons/scuba_diving'),
  'sd': () => import('./icons/sd'),
  'sd_card': () => import('./icons/sd_card'),
  'sd_card_alert': () => import('./icons/sd_card_alert'),
  'sd_storage': () => import('./icons/sd_storage'),
  'search': () => import('./icons/search'),
  'search_off': () => import('./icons/search_off'),
  'security': () => import('./icons/security'),
  'security_update': () => import('./icons/security_update'),
  'security_update_good': () => import('./icons/security_update_good'),
  'security_update_warning': () => import('./icons/security_update_warning'),
  'segment': () => import('./icons/segment'),
  'select_all': () => import('./icons/select_all'),
  'self_improvement': () => import('./icons/self_improvement'),
  'sell': () => import('./icons/sell'),
  'send': () => import('./icons/send'),
  'send_and_archive': () => import('./icons/send_and_archive'),
  'send_time_extension': () => import('./icons/send_time_extension'),
  'send_to_mobile': () => import('./icons/send_to_mobile'),
  'sensor_door': () => import('./icons/sensor_door'),
  'sensor_occupied': () => import('./icons/sensor_occupied'),
  'sensor_window': () => import('./icons/sensor_window'),
  'sensors': () => import('./icons/sensors'),
  'sensors_off': () => import('./icons/sensors_off'),
  'sentiment_dissatisfied': () => import('./icons/sentiment_dissatisfied'),
  'sentiment_neutral': () => import('./icons/sentiment_neutral'),
  'sentiment_satisfied': () => import('./icons/sentiment_satisfied'),
  'sentiment_satisfied_alt': () => import('./icons/sentiment_satisfied_alt'),
  'sentiment_very_dissatisfied': () => import('./icons/sentiment_very_dissatisfied'),
  'sentiment_very_satisfied': () => import('./icons/sentiment_very_satisfied'),
  'set_meal': () => import('./icons/set_meal'),
  'settings': () => import('./icons/settings'),
  'settings_accessibility': () => import('./icons/settings_accessibility'),
  'settings_applications': () => import('./icons/settings_applications'),
  'settings_backup_restore': () => import('./icons/settings_backup_restore'),
  'settings_bluetooth': () => import('./icons/settings_bluetooth'),
  'settings_brightness': () => import('./icons/settings_brightness'),
  'settings_cell': () => import('./icons/settings_cell'),
  'settings_ethernet': () => import('./icons/settings_ethernet'),
  'settings_input_antenna': () => import('./icons/settings_input_antenna'),
  'settings_input_component': () => import('./icons/settings_input_component'),
  'settings_input_composite': () => import('./icons/settings_input_composite'),
  'settings_input_hdmi': () => import('./icons/settings_input_hdmi'),
  'settings_input_svideo': () => import('./icons/settings_input_svideo'),
  'settings_overscan': () => import('./icons/settings_overscan'),
  'settings_phone': () => import('./icons/settings_phone'),
  'settings_power': () => import('./icons/settings_power'),
  'settings_remote': () => import('./icons/settings_remote'),
  'settings_suggest': () => import('./icons/settings_suggest'),
  'settings_system_daydream': () => import('./icons/settings_system_daydream'),
  'settings_voice': () => import('./icons/settings_voice'),
  'sevenk': () => import('./icons/sevenk'),
  'sevenk_plus': () => import('./icons/sevenk_plus'),
  'sevenmp': () => import('./icons/sevenmp'),
  'severe_cold': () => import('./icons/severe_cold'),
  'shape_line': () => import('./icons/shape_line'),
  'share': () => import('./icons/share'),
  'share_location': () => import('./icons/share_location'),
  'shield': () => import('./icons/shield'),
  'shield_moon': () => import('./icons/shield_moon'),
  'shop': () => import('./icons/shop'),
  'shop_2': () => import('./icons/shop_2'),
  'shop_two': () => import('./icons/shop_two'),
  'shopping_bag': () => import('./icons/shopping_bag'),
  'shopping_basket': () => import('./icons/shopping_basket'),
  'shopping_cart': () => import('./icons/shopping_cart'),
  'shopping_cart_checkout': () => import('./icons/shopping_cart_checkout'),
  'short_text': () => import('./icons/short_text'),
  'shortcut': () => import('./icons/shortcut'),
  'show_chart': () => import('./icons/show_chart'),
  'shower': () => import('./icons/shower'),
  'shuffle': () => import('./icons/shuffle'),
  'shuffle_on': () => import('./icons/shuffle_on'),
  'shutter_speed': () => import('./icons/shutter_speed'),
  'sick': () => import('./icons/sick'),
  'sign_language': () => import('./icons/sign_language'),
  'signal_cellular_0_bar': () => import('./icons/signal_cellular_0_bar'),
  'signal_cellular_4_bar': () => import('./icons/signal_cellular_4_bar'),
  'signal_cellular_alt': () => import('./icons/signal_cellular_alt'),
  'signal_cellular_alt_1_bar': () => import('./icons/signal_cellular_alt_1_bar'),
  'signal_cellular_alt_2_bar': () => import('./icons/signal_cellular_alt_2_bar'),
  'signal_cellular_connected_no_internet_0_bar': () => import('./icons/signal_cellular_connected_no_internet_0_bar'),
  'signal_cellular_connected_no_internet_4_bar': () => import('./icons/signal_cellular_connected_no_internet_4_bar'),
  'signal_cellular_no_sim': () => import('./icons/signal_cellular_no_sim'),
  'signal_cellular_nodata': () => import('./icons/signal_cellular_nodata'),
  'signal_cellular_null': () => import('./icons/signal_cellular_null'),
  'signal_cellular_off': () => import('./icons/signal_cellular_off'),
  'signal_wifi_0_bar': () => import('./icons/signal_wifi_0_bar'),
  'signal_wifi_4_bar': () => import('./icons/signal_wifi_4_bar'),
  'signal_wifi_4_bar_lock': () => import('./icons/signal_wifi_4_bar_lock'),
  'signal_wifi_bad': () => import('./icons/signal_wifi_bad'),
  'signal_wifi_connected_no_internet_4': () => import('./icons/signal_wifi_connected_no_internet_4'),
  'signal_wifi_off': () => import('./icons/signal_wifi_off'),
  'signal_wifi_statusbar_4_bar': () => import('./icons/signal_wifi_statusbar_4_bar'),
  'signal_wifi_statusbar_connected_no_internet_4': () => import('./icons/signal_wifi_statusbar_connected_no_internet_4'),
  'signal_wifi_statusbar_null': () => import('./icons/signal_wifi_statusbar_null'),
  'signpost': () => import('./icons/signpost'),
  'sim_card': () => import('./icons/sim_card'),
  'sim_card_alert': () => import('./icons/sim_card_alert'),
  'sim_card_download': () => import('./icons/sim_card_download'),
  'single_bed': () => import('./icons/single_bed'),
  'sip': () => import('./icons/sip'),
  'sivnteenmp': () => import('./icons/sivnteenmp'),
  'six_ft_apart': () => import('./icons/six_ft_apart'),
  'sixk': () => import('./icons/sixk'),
  'sixk_plus': () => import('./icons/sixk_plus'),
  'sixmp': () => import('./icons/sixmp'),
  'sixteenmp': () => import('./icons/sixteenmp'),
  'sixtyfps': () => import('./icons/sixtyfps'),
  'sixtyfps_select': () => import('./icons/sixtyfps_select'),
  'skateboarding': () => import('./icons/skateboarding'),
  'skip_next': () => import('./icons/skip_next'),
  'skip_previous': () => import('./icons/skip_previous'),
  'sledding': () => import('./icons/sledding'),
  'slideshow': () => import('./icons/slideshow'),
  'slow_motion_video': () => import('./icons/slow_motion_video'),
  'smart_button': () => import('./icons/smart_button'),
  'smart_display': () => import('./icons/smart_display'),
  'smart_screen': () => import('./icons/smart_screen'),
  'smart_toy': () => import('./icons/smart_toy'),
  'smartphone': () => import('./icons/smartphone'),
  'smoke_free': () => import('./icons/smoke_free'),
  'smoking_rooms': () => import('./icons/smoking_rooms'),
  'sms': () => import('./icons/sms'),
  'sms_failed': () => import('./icons/sms_failed'),
  'snippet_folder': () => import('./icons/snippet_folder'),
  'snooze': () => import('./icons/snooze'),
  'snowboarding': () => import('./icons/snowboarding'),
  'snowmobile': () => import('./icons/snowmobile'),
  'snowshoeing': () => import('./icons/snowshoeing'),
  'soap': () => import('./icons/soap'),
  'social_distance': () => import('./icons/social_distance'),
  'solar_power': () => import('./icons/solar_power'),
  'sort': () => import('./icons/sort'),
  'sort_by_alpha': () => import('./icons/sort_by_alpha'),
  'sos': () => import('./icons/sos'),
  'soup_kitchen': () => import('./icons/soup_kitchen'),
  'source': () => import('./icons/source'),
  'south': () => import('./icons/south'),
  'south_america': () => import('./icons/south_america'),
  'south_east': () => import('./icons/south_east'),
  'south_west': () => import('./icons/south_west'),
  'spa': () => import('./icons/spa'),
  'space_bar': () => import('./icons/space_bar'),
  'space_dashboard': () => import('./icons/space_dashboard'),
  'spatial_audio': () => import('./icons/spatial_audio'),
  'spatial_audio_off': () => import('./icons/spatial_audio_off'),
  'spatial_tracking': () => import('./icons/spatial_tracking'),
  'speaker': () => import('./icons/speaker'),
  'speaker_group': () => import('./icons/speaker_group'),
  'speaker_notes': () => import('./icons/speaker_notes'),
  'speaker_notes_off': () => import('./icons/speaker_notes_off'),
  'speaker_phone': () => import('./icons/speaker_phone'),
  'speed': () => import('./icons/speed'),
  'spellcheck': () => import('./icons/spellcheck'),
  'splitscreen': () => import('./icons/splitscreen'),
  'spoke': () => import('./icons/spoke'),
  'sports': () => import('./icons/sports'),
  'sports_bar': () => import('./icons/sports_bar'),
  'sports_baseball': () => import('./icons/sports_baseball'),
  'sports_basketball': () => import('./icons/sports_basketball'),
  'sports_cricket': () => import('./icons/sports_cricket'),
  'sports_esports': () => import('./icons/sports_esports'),
  'sports_football': () => import('./icons/sports_football'),
  'sports_golf': () => import('./icons/sports_golf'),
  'sports_gymnastics': () => import('./icons/sports_gymnastics'),
  'sports_handball': () => import('./icons/sports_handball'),
  'sports_hockey': () => import('./icons/sports_hockey'),
  'sports_kabaddi': () => import('./icons/sports_kabaddi'),
  'sports_martial_arts': () => import('./icons/sports_martial_arts'),
  'sports_mma': () => import('./icons/sports_mma'),
  'sports_motorsports': () => import('./icons/sports_motorsports'),
  'sports_rugby': () => import('./icons/sports_rugby'),
  'sports_score': () => import('./icons/sports_score'),
  'sports_soccer': () => import('./icons/sports_soccer'),
  'sports_tennis': () => import('./icons/sports_tennis'),
  'sports_volleyball': () => import('./icons/sports_volleyball'),
  'square': () => import('./icons/square'),
  'square_foot': () => import('./icons/square_foot'),
  'ssid_chart': () => import('./icons/ssid_chart'),
  'stacked_bar_chart': () => import('./icons/stacked_bar_chart'),
  'stacked_line_chart': () => import('./icons/stacked_line_chart'),
  'stadium': () => import('./icons/stadium'),
  'stairs': () => import('./icons/stairs'),
  'star': () => import('./icons/star'),
  'star_border': () => import('./icons/star_border'),
  'star_border_purple500': () => import('./icons/star_border_purple500'),
  'star_half': () => import('./icons/star_half'),
  'star_outline': () => import('./icons/star_outline'),
  'star_purple500': () => import('./icons/star_purple500'),
  'star_rate': () => import('./icons/star_rate'),
  'stars': () => import('./icons/stars'),
  'start': () => import('./icons/start'),
  'stay_current_landscape': () => import('./icons/stay_current_landscape'),
  'stay_current_portrait': () => import('./icons/stay_current_portrait'),
  'stay_primary_landscape': () => import('./icons/stay_primary_landscape'),
  'stay_primary_portrait': () => import('./icons/stay_primary_portrait'),
  'sticky_note_2': () => import('./icons/sticky_note_2'),
  'stop': () => import('./icons/stop'),
  'stop_circle': () => import('./icons/stop_circle'),
  'stop_screen_share': () => import('./icons/stop_screen_share'),
  'storage': () => import('./icons/storage'),
  'store': () => import('./icons/store'),
  'store_mall_directory': () => import('./icons/store_mall_directory'),
  'storefront': () => import('./icons/storefront'),
  'storm': () => import('./icons/storm'),
  'straight': () => import('./icons/straight'),
  'straighten': () => import('./icons/straighten'),
  'stream': () => import('./icons/stream'),
  'streetview': () => import('./icons/streetview'),
  'strikethrough_s': () => import('./icons/strikethrough_s'),
  'stroller': () => import('./icons/stroller'),
  'style': () => import('./icons/style'),
  'subdirectory_arrow_left': () => import('./icons/subdirectory_arrow_left'),
  'subdirectory_arrow_right': () => import('./icons/subdirectory_arrow_right'),
  'subject': () => import('./icons/subject'),
  'subscript': () => import('./icons/subscript'),
  'subscriptions': () => import('./icons/subscriptions'),
  'subtitles': () => import('./icons/subtitles'),
  'subtitles_off': () => import('./icons/subtitles_off'),
  'subway': () => import('./icons/subway'),
  'summarize': () => import('./icons/summarize'),
  'superscript': () => import('./icons/superscript'),
  'supervised_user_circle': () => import('./icons/supervised_user_circle'),
  'supervisor_account': () => import('./icons/supervisor_account'),
  'support': () => import('./icons/support'),
  'support_agent': () => import('./icons/support_agent'),
  'surfing': () => import('./icons/surfing'),
  'surround_sound': () => import('./icons/surround_sound'),
  'swap_calls': () => import('./icons/swap_calls'),
  'swap_horiz': () => import('./icons/swap_horiz'),
  'swap_horizontal_circle': () => import('./icons/swap_horizontal_circle'),
  'swap_vert': () => import('./icons/swap_vert'),
  'swap_vertical_circle': () => import('./icons/swap_vertical_circle'),
  'swipe': () => import('./icons/swipe'),
  'swipe_down': () => import('./icons/swipe_down'),
  'swipe_down_alt': () => import('./icons/swipe_down_alt'),
  'swipe_left': () => import('./icons/swipe_left'),
  'swipe_left_alt': () => import('./icons/swipe_left_alt'),
  'swipe_right': () => import('./icons/swipe_right'),
  'swipe_right_alt': () => import('./icons/swipe_right_alt'),
  'swipe_up': () => import('./icons/swipe_up'),
  'swipe_up_alt': () => import('./icons/swipe_up_alt'),
  'swipe_vertical': () => import('./icons/swipe_vertical'),
  'switch_access_shortcut': () => import('./icons/switch_access_shortcut'),
  'switch_access_shortcut_add': () => import('./icons/switch_access_shortcut_add'),
  'switch_account': () => import('./icons/switch_account'),
  'switch_camera': () => import('./icons/switch_camera'),
  'switch_left': () => import('./icons/switch_left'),
  'switch_right': () => import('./icons/switch_right'),
  'switch_video': () => import('./icons/switch_video'),
  'synagogue': () => import('./icons/synagogue'),
  'sync': () => import('./icons/sync'),
  'sync_alt': () => import('./icons/sync_alt'),
  'sync_disabled': () => import('./icons/sync_disabled'),
  'sync_lock': () => import('./icons/sync_lock'),
  'sync_problem': () => import('./icons/sync_problem'),
  'system_security_update': () => import('./icons/system_security_update'),
  'system_security_update_good': () => import('./icons/system_security_update_good'),
  'system_security_update_warning': () => import('./icons/system_security_update_warning'),
  'system_update': () => import('./icons/system_update'),
  'system_update_alt': () => import('./icons/system_update_alt'),
  'tab': () => import('./icons/tab'),
  'tab_unselected': () => import('./icons/tab_unselected'),
  'table_bar': () => import('./icons/table_bar'),
  'table_chart': () => import('./icons/table_chart'),
  'table_restaurant': () => import('./icons/table_restaurant'),
  'table_rows': () => import('./icons/table_rows'),
  'table_view': () => import('./icons/table_view'),
  'tablet': () => import('./icons/tablet'),
  'tablet_android': () => import('./icons/tablet_android'),
  'tablet_mac': () => import('./icons/tablet_mac'),
  'tag': () => import('./icons/tag'),
  'tag_faces': () => import('./icons/tag_faces'),
  'takeout_dining': () => import('./icons/takeout_dining'),
  'tap_and_play': () => import('./icons/tap_and_play'),
  'tapas': () => import('./icons/tapas'),
  'task': () => import('./icons/task'),
  'task_alt': () => import('./icons/task_alt'),
  'taxi_alert': () => import('./icons/taxi_alert'),
  'temple_buddhist': () => import('./icons/temple_buddhist'),
  'temple_hindu': () => import('./icons/temple_hindu'),
  'tenk': () => import('./icons/tenk'),
  'tenmp': () => import('./icons/tenmp'),
  'terminal': () => import('./icons/terminal'),
  'terrain': () => import('./icons/terrain'),
  'text_decrease': () => import('./icons/text_decrease'),
  'text_fields': () => import('./icons/text_fields'),
  'text_format': () => import('./icons/text_format'),
  'text_increase': () => import('./icons/text_increase'),
  'text_rotate_up': () => import('./icons/text_rotate_up'),
  'text_rotate_vertical': () => import('./icons/text_rotate_vertical'),
  'text_rotation_angledown': () => import('./icons/text_rotation_angledown'),
  'text_rotation_angleup': () => import('./icons/text_rotation_angleup'),
  'text_rotation_down': () => import('./icons/text_rotation_down'),
  'text_rotation_none': () => import('./icons/text_rotation_none'),
  'text_snippet': () => import('./icons/text_snippet'),
  'textsms': () => import('./icons/textsms'),
  'texture': () => import('./icons/texture'),
  'theater_comedy': () => import('./icons/theater_comedy'),
  'theaters': () => import('./icons/theaters'),
  'thermostat': () => import('./icons/thermostat'),
  'thermostat_auto': () => import('./icons/thermostat_auto'),
  'thirteenmp': () => import('./icons/thirteenmp'),
  'thirtyfps': () => import('./icons/thirtyfps'),
  'thirtyfps_select': () => import('./icons/thirtyfps_select'),
  'threed_rotation': () => import('./icons/threed_rotation'),
  'threeg_mobiledata': () => import('./icons/threeg_mobiledata'),
  'threek': () => import('./icons/threek'),
  'threek_plus': () => import('./icons/threek_plus'),
  'threemp': () => import('./icons/threemp'),
  'threep': () => import('./icons/threep'),
  'thumb_down': () => import('./icons/thumb_down'),
  'thumb_down_alt': () => import('./icons/thumb_down_alt'),
  'thumb_down_off_alt': () => import('./icons/thumb_down_off_alt'),
  'thumb_up': () => import('./icons/thumb_up'),
  'thumb_up_alt': () => import('./icons/thumb_up_alt'),
  'thumb_up_off_alt': () => import('./icons/thumb_up_off_alt'),
  'thumbs_up_down': () => import('./icons/thumbs_up_down'),
  'thunderstorm': () => import('./icons/thunderstorm'),
  'time_to_leave': () => import('./icons/time_to_leave'),
  'timelapse': () => import('./icons/timelapse'),
  'timeline': () => import('./icons/timeline'),
  'timer': () => import('./icons/timer'),
  'timer_10': () => import('./icons/timer_10'),
  'timer_10_select': () => import('./icons/timer_10_select'),
  'timer_3': () => import('./icons/timer_3'),
  'timer_3_select': () => import('./icons/timer_3_select'),
  'timer_off': () => import('./icons/timer_off'),
  'tips_and_updates': () => import('./icons/tips_and_updates'),
  'tire_repair': () => import('./icons/tire_repair'),
  'title': () => import('./icons/title'),
  'toc': () => import('./icons/toc'),
  'today': () => import('./icons/today'),
  'toggle_off': () => import('./icons/toggle_off'),
  'toggle_on': () => import('./icons/toggle_on'),
  'token': () => import('./icons/token'),
  'toll': () => import('./icons/toll'),
  'tonality': () => import('./icons/tonality'),
  'topic': () => import('./icons/topic'),
  'tornado': () => import('./icons/tornado'),
  'touch_app': () => import('./icons/touch_app'),
  'tour': () => import('./icons/tour'),
  'toys': () => import('./icons/toys'),
  'track_changes': () => import('./icons/track_changes'),
  'traffic': () => import('./icons/traffic'),
  'train': () => import('./icons/train'),
  'tram': () => import('./icons/tram'),
  'transcribe': () => import('./icons/transcribe'),
  'transfer_within_a_station': () => import('./icons/transfer_within_a_station'),
  'transform': () => import('./icons/transform'),
  'transgender': () => import('./icons/transgender'),
  'transit_enterexit': () => import('./icons/transit_enterexit'),
  'translate': () => import('./icons/translate'),
  'travel_explore': () => import('./icons/travel_explore'),
  'trending_down': () => import('./icons/trending_down'),
  'trending_flat': () => import('./icons/trending_flat'),
  'trending_up': () => import('./icons/trending_up'),
  'trip_origin': () => import('./icons/trip_origin'),
  'troubleshoot': () => import('./icons/troubleshoot'),
  'try': () => import('./icons/try'),
  'tsunami': () => import('./icons/tsunami'),
  'tty': () => import('./icons/tty'),
  'tune': () => import('./icons/tune'),
  'tungsten': () => import('./icons/tungsten'),
  'turn_left': () => import('./icons/turn_left'),
  'turn_right': () => import('./icons/turn_right'),
  'turn_sharp_left': () => import('./icons/turn_sharp_left'),
  'turn_sharp_right': () => import('./icons/turn_sharp_right'),
  'turn_slight_left': () => import('./icons/turn_slight_left'),
  'turn_slight_right': () => import('./icons/turn_slight_right'),
  'turned_in': () => import('./icons/turned_in'),
  'turned_in_not': () => import('./icons/turned_in_not'),
  'tv': () => import('./icons/tv'),
  'tv_off': () => import('./icons/tv_off'),
  'twelvemp': () => import('./icons/twelvemp'),
  'twentyfourmp': () => import('./icons/twentyfourmp'),
  'twentymp': () => import('./icons/twentymp'),
  'twentyonemp': () => import('./icons/twentyonemp'),
  'twentytwomp': () => import('./icons/twentytwomp'),
  'twentyyhreemp': () => import('./icons/twentyyhreemp'),
  'two_wheeler': () => import('./icons/two_wheeler'),
  'twok': () => import('./icons/twok'),
  'twok_plus': () => import('./icons/twok_plus'),
  'twomp': () => import('./icons/twomp'),
  'type_specimen': () => import('./icons/type_specimen'),
  'u_turn_left': () => import('./icons/u_turn_left'),
  'u_turn_right': () => import('./icons/u_turn_right'),
  'umbrella': () => import('./icons/umbrella'),
  'unarchive': () => import('./icons/unarchive'),
  'undo': () => import('./icons/undo'),
  'unfold_less': () => import('./icons/unfold_less'),
  'unfold_less_double': () => import('./icons/unfold_less_double'),
  'unfold_more': () => import('./icons/unfold_more'),
  'unfold_more_double': () => import('./icons/unfold_more_double'),
  'unpublished': () => import('./icons/unpublished'),
  'unsubscribe': () => import('./icons/unsubscribe'),
  'upcoming': () => import('./icons/upcoming'),
  'update': () => import('./icons/update'),
  'update_disabled': () => import('./icons/update_disabled'),
  'upgrade': () => import('./icons/upgrade'),
  'upload': () => import('./icons/upload'),
  'upload_file': () => import('./icons/upload_file'),
  'usb': () => import('./icons/usb'),
  'usb_off': () => import('./icons/usb_off'),
  'vaccines': () => import('./icons/vaccines'),
  'vape_free': () => import('./icons/vape_free'),
  'vaping_rooms': () => import('./icons/vaping_rooms'),
  'verified': () => import('./icons/verified'),
  'verified_user': () => import('./icons/verified_user'),
  'vertical_align_bottom': () => import('./icons/vertical_align_bottom'),
  'vertical_align_center': () => import('./icons/vertical_align_center'),
  'vertical_align_top': () => import('./icons/vertical_align_top'),
  'vertical_distribute': () => import('./icons/vertical_distribute'),
  'vertical_shades': () => import('./icons/vertical_shades'),
  'vertical_shades_closed': () => import('./icons/vertical_shades_closed'),
  'vertical_split': () => import('./icons/vertical_split'),
  'vibration': () => import('./icons/vibration'),
  'video_call': () => import('./icons/video_call'),
  'video_camera_back': () => import('./icons/video_camera_back'),
  'video_camera_front': () => import('./icons/video_camera_front'),
  'video_chat': () => import('./icons/video_chat'),
  'video_file': () => import('./icons/video_file'),
  'video_label': () => import('./icons/video_label'),
  'video_library': () => import('./icons/video_library'),
  'video_settings': () => import('./icons/video_settings'),
  'video_stable': () => import('./icons/video_stable'),
  'videocam': () => import('./icons/videocam'),
  'videocam_off': () => import('./icons/videocam_off'),
  'videogame_asset': () => import('./icons/videogame_asset'),
  'videogame_asset_off': () => import('./icons/videogame_asset_off'),
  'view_agenda': () => import('./icons/view_agenda'),
  'view_array': () => import('./icons/view_array'),
  'view_carousel': () => import('./icons/view_carousel'),
  'view_column': () => import('./icons/view_column'),
  'view_comfy': () => import('./icons/view_comfy'),
  'view_comfy_alt': () => import('./icons/view_comfy_alt'),
  'view_compact': () => import('./icons/view_compact'),
  'view_compact_alt': () => import('./icons/view_compact_alt'),
  'view_cozy': () => import('./icons/view_cozy'),
  'view_day': () => import('./icons/view_day'),
  'view_headline': () => import('./icons/view_headline'),
  'view_in_ar': () => import('./icons/view_in_ar'),
  'view_kanban': () => import('./icons/view_kanban'),
  'view_list': () => import('./icons/view_list'),
  'view_module': () => import('./icons/view_module'),
  'view_quilt': () => import('./icons/view_quilt'),
  'view_sidebar': () => import('./icons/view_sidebar'),
  'view_stream': () => import('./icons/view_stream'),
  'view_timeline': () => import('./icons/view_timeline'),
  'view_week': () => import('./icons/view_week'),
  'vignette': () => import('./icons/vignette'),
  'villa': () => import('./icons/villa'),
  'visibility': () => import('./icons/visibility'),
  'visibility_off': () => import('./icons/visibility_off'),
  'voice_chat': () => import('./icons/voice_chat'),
  'voice_over_off': () => import('./icons/voice_over_off'),
  'voicemail': () => import('./icons/voicemail'),
  'volcano': () => import('./icons/volcano'),
  'volume_down': () => import('./icons/volume_down'),
  'volume_mute': () => import('./icons/volume_mute'),
  'volume_off': () => import('./icons/volume_off'),
  'volume_up': () => import('./icons/volume_up'),
  'volunteer_activism': () => import('./icons/volunteer_activism'),
  'vpn_key': () => import('./icons/vpn_key'),
  'vpn_key_off': () => import('./icons/vpn_key_off'),
  'vpn_lock': () => import('./icons/vpn_lock'),
  'vrpano': () => import('./icons/vrpano'),
  'wallet': () => import('./icons/wallet'),
  'wallpaper': () => import('./icons/wallpaper'),
  'warehouse': () => import('./icons/warehouse'),
  'warning': () => import('./icons/warning'),
  'warning_amber': () => import('./icons/warning_amber'),
  'wash': () => import('./icons/wash'),
  'watch': () => import('./icons/watch'),
  'watch_later': () => import('./icons/watch_later'),
  'watch_off': () => import('./icons/watch_off'),
  'water': () => import('./icons/water'),
  'water_damage': () => import('./icons/water_damage'),
  'water_drop': () => import('./icons/water_drop'),
  'waterfall_chart': () => import('./icons/waterfall_chart'),
  'waves': () => import('./icons/waves'),
  'waving_hand': () => import('./icons/waving_hand'),
  'wb_auto': () => import('./icons/wb_auto'),
  'wb_cloudy': () => import('./icons/wb_cloudy'),
  'wb_incandescent': () => import('./icons/wb_incandescent'),
  'wb_iridescent': () => import('./icons/wb_iridescent'),
  'wb_shade': () => import('./icons/wb_shade'),
  'wb_sunny': () => import('./icons/wb_sunny'),
  'wb_twilight': () => import('./icons/wb_twilight'),
  'wc': () => import('./icons/wc'),
  'web': () => import('./icons/web'),
  'web_asset': () => import('./icons/web_asset'),
  'web_asset_off': () => import('./icons/web_asset_off'),
  'web_stories': () => import('./icons/web_stories'),
  'webhook': () => import('./icons/webhook'),
  'weekend': () => import('./icons/weekend'),
  'west': () => import('./icons/west'),
  'whatshot': () => import('./icons/whatshot'),
  'wheelchair_pickup': () => import('./icons/wheelchair_pickup'),
  'where_to_vote': () => import('./icons/where_to_vote'),
  'widgets': () => import('./icons/widgets'),
  'width_full': () => import('./icons/width_full'),
  'width_normal': () => import('./icons/width_normal'),
  'width_wide': () => import('./icons/width_wide'),
  'wifi': () => import('./icons/wifi'),
  'wifi_1_bar': () => import('./icons/wifi_1_bar'),
  'wifi_2_bar': () => import('./icons/wifi_2_bar'),
  'wifi_calling': () => import('./icons/wifi_calling'),
  'wifi_calling_3': () => import('./icons/wifi_calling_3'),
  'wifi_channel': () => import('./icons/wifi_channel'),
  'wifi_find': () => import('./icons/wifi_find'),
  'wifi_lock': () => import('./icons/wifi_lock'),
  'wifi_off': () => import('./icons/wifi_off'),
  'wifi_password': () => import('./icons/wifi_password'),
  'wifi_protected_setup': () => import('./icons/wifi_protected_setup'),
  'wifi_tethering': () => import('./icons/wifi_tethering'),
  'wifi_tethering_error': () => import('./icons/wifi_tethering_error'),
  'wifi_tethering_off': () => import('./icons/wifi_tethering_off'),
  'wind_power': () => import('./icons/wind_power'),
  'window': () => import('./icons/window'),
  'wine_bar': () => import('./icons/wine_bar'),
  'woman': () => import('./icons/woman'),
  'woman_2': () => import('./icons/woman_2'),
  'work': () => import('./icons/work'),
  'work_history': () => import('./icons/work_history'),
  'work_off': () => import('./icons/work_off'),
  'work_outline': () => import('./icons/work_outline'),
  'workspace_premium': () => import('./icons/workspace_premium'),
  'workspaces': () => import('./icons/workspaces'),
  'wrap_text': () => import('./icons/wrap_text'),
  'wrong_location': () => import('./icons/wrong_location'),
  'wysiwyg': () => import('./icons/wysiwyg'),
  'yard': () => import('./icons/yard'),
  'youtube_searched_for': () => import('./icons/youtube_searched_for'),
  'zoom_in': () => import('./icons/zoom_in'),
  'zoom_in_map': () => import('./icons/zoom_in_map'),
  'zoom_out': () => import('./icons/zoom_out'),
  'zoom_out_map': () => import('./icons/zoom_out_map'),
};
export default dynamicIconImports;
